/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PlatformIntroRouteImport } from './routes/platform-intro'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AppRouteImport } from './routes/_app'
import { Route as StrategyMagicLinkRouteImport } from './routes/strategy.magic-link'
import { Route as DonateSlugRouteImport } from './routes/donate/$slug'
import { Route as CheckoutSuccessRouteImport } from './routes/checkout.success'
import { Route as CheckoutTokenRouteImport } from './routes/checkout.$token'
import { Route as CheckoutSuccessTokenRouteImport } from './routes/checkout-success.$token'
import { Route as AuthVerifyEmailRouteImport } from './routes/auth/verify-email'
import { Route as AuthVerifyRouteImport } from './routes/auth/verify'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthRegisterInviteRouteImport } from './routes/auth/register-invite'
import { Route as AuthPhoneVerificationRouteImport } from './routes/auth/phone-verification'
import { Route as AuthGoogleCallbackRouteImport } from './routes/auth/google-callback'
import { Route as AuthCreatePasswordRouteImport } from './routes/auth/create-password'
import { Route as AuthAcceptInviteRouteImport } from './routes/auth/accept-invite'
import { Route as AdminSplatRouteImport } from './routes/admin.$'
import { Route as AuthSignupRouteImport } from './routes/_auth/signup'
import { Route as AuthPendingApprovalRouteImport } from './routes/_auth/pending-approval'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AppSettingsRouteImport } from './routes/_app/_settings'
import { Route as AppIndexRouteImport } from './routes/_app/_.index'
import { Route as AuthLoginGoogleCallbackRouteImport } from './routes/_auth/login.google-callback'
import { Route as AppSettingsTeamRouteImport } from './routes/_app/_settings.team'
import { Route as AppSettingsSettingsRouteImport } from './routes/_app/_settings.settings'
import { Route as AppSettingsFundraisingSettingsRouteImport } from './routes/_app/_settings.fundraising-settings'
import { Route as AppSettingsEmailSettingsRouteImport } from './routes/_app/_settings.email-settings'
import { Route as AppSettingsBillingRouteImport } from './routes/_app/_settings.billing'
import { Route as AppYourVotersRouteImport } from './routes/_app/_.your-voters'
import { Route as AppVoterFileStatsRouteImport } from './routes/_app/_.voter-file-stats'
import { Route as AppVolunteersRouteImport } from './routes/_app/_.volunteers'
import { Route as AppTextBankingRouteImport } from './routes/_app/_.text-banking'
import { Route as AppTasksRouteImport } from './routes/_app/_.tasks'
import { Route as AppStrategyRouteImport } from './routes/_app/_.strategy'
import { Route as AppProfileRouteImport } from './routes/_app/_.profile'
import { Route as AppPhoneBankingRouteImport } from './routes/_app/_.phone-banking'
import { Route as AppOnboardingRouteImport } from './routes/_app/_.onboarding'
import { Route as AppInterviewRouteImport } from './routes/_app/_.interview'
import { Route as AppFundraisingRouteImport } from './routes/_app/_.fundraising'
import { Route as AppFormsRouteImport } from './routes/_app/_.forms'
import { Route as AppEmailRouteImport } from './routes/_app/_.email'
import { Route as AppDailyBriefingRouteImport } from './routes/_app/_.daily-briefing'
import { Route as AppContactsRouteImport } from './routes/_app/_.contacts'
import { Route as AppCommandCenterRouteImport } from './routes/_app/_.command-center'
import { Route as AppCallTimeRouteImport } from './routes/_app/_.call-time'
import { Route as AppBallotAccessRouteImport } from './routes/_app/_.ballot-access'
import { Route as AppActionGroupsRouteImport } from './routes/_app/_.action-groups'
import { Route as AppVoterFileStatsIndexRouteImport } from './routes/_app/_.voter-file-stats.index'
import { Route as AppVolunteersIndexRouteImport } from './routes/_app/_.volunteers.index'
import { Route as AppTextBankingIndexRouteImport } from './routes/_app/_.text-banking.index'
import { Route as AppTasksIndexRouteImport } from './routes/_app/_.tasks.index'
import { Route as AppStrategyIndexRouteImport } from './routes/_app/_.strategy.index'
import { Route as AppPhoneBankingIndexRouteImport } from './routes/_app/_.phone-banking.index'
import { Route as AppOutreachIndexRouteImport } from './routes/_app/_.outreach.index'
import { Route as AppFundraisingIndexRouteImport } from './routes/_app/_.fundraising.index'
import { Route as AppFormsIndexRouteImport } from './routes/_app/_.forms.index'
import { Route as AppEmailIndexRouteImport } from './routes/_app/_.email.index'
import { Route as AppDailyBriefingIndexRouteImport } from './routes/_app/_.daily-briefing.index'
import { Route as AppContactsIndexRouteImport } from './routes/_app/_.contacts.index'
import { Route as AppCampaignsIndexRouteImport } from './routes/_app/_.campaigns.index'
import { Route as AppCallTimeIndexRouteImport } from './routes/_app/_.call-time.index'
import { Route as AppBallotAccessIndexRouteImport } from './routes/_app/_.ballot-access.index'
import { Route as AppActionGroupsIndexRouteImport } from './routes/_app/_.action-groups.index'
import { Route as AppVolunteersVolunteerIdRouteImport } from './routes/_app/_.volunteers.$volunteerId'
import { Route as AppTextBankingNewRouteImport } from './routes/_app/_.text-banking.new'
import { Route as AppTextBankingCampaignIdRouteImport } from './routes/_app/_.text-banking.$campaignId'
import { Route as AppStrategyVersionsRouteImport } from './routes/_app/_.strategy.versions'
import { Route as AppStrategyRoadmapRouteImport } from './routes/_app/_.strategy.roadmap'
import { Route as AppStrategyRevealRouteImport } from './routes/_app/_.strategy.reveal'
import { Route as AppStrategyQaRouteImport } from './routes/_app/_.strategy.qa'
import { Route as AppStrategyDashboardRouteImport } from './routes/_app/_.strategy.dashboard'
import { Route as AppStrategyBriefRouteImport } from './routes/_app/_.strategy.brief'
import { Route as AppPhoneBankingNewRouteImport } from './routes/_app/_.phone-banking.new'
import { Route as AppPhoneBankingCampaignIdRouteImport } from './routes/_app/_.phone-banking.$campaignId'
import { Route as AppOutreachNewRouteImport } from './routes/_app/_.outreach.new'
import { Route as AppOutreachGroupAudiencesRouteImport } from './routes/_app/_.outreach.group-audiences'
import { Route as AppOutreachAudiencesRouteImport } from './routes/_app/_.outreach.audiences'
import { Route as AppOutreachOcIdRouteImport } from './routes/_app/_.outreach.$ocId'
import { Route as AppOnboardingMicSetupRouteImport } from './routes/_app/_.onboarding.mic-setup'
import { Route as AppOnboardingInterviewIntroRouteImport } from './routes/_app/_.onboarding.interview-intro'
import { Route as AppOnboardingInterviewFollowUpRouteImport } from './routes/_app/_.onboarding.interview-follow-up'
import { Route as AppOnboardingGetStartedRouteImport } from './routes/_app/_.onboarding.get-started'
import { Route as AppOnboardingGeneratingRouteImport } from './routes/_app/_.onboarding.generating'
import { Route as AppOnboardingAcceptTosRouteImport } from './routes/_app/_.onboarding.accept-tos'
import { Route as AppInterviewSessionRouteImport } from './routes/_app/_.interview.session'
import { Route as AppFundraisingSetupRouteImport } from './routes/_app/_.fundraising.setup'
import { Route as AppFundraisingSettingsRouteImport } from './routes/_app/_.fundraising.settings'
import { Route as AppFundraisingPageBuilderRouteImport } from './routes/_app/_.fundraising.page-builder'
import { Route as AppFundraisingDonationsRouteImport } from './routes/_app/_.fundraising.donations'
import { Route as AppFundraisingComplianceRouteImport } from './routes/_app/_.fundraising.compliance'
import { Route as AppFormsNewRouteImport } from './routes/_app/_.forms.new'
import { Route as AppFormsFormIdRouteImport } from './routes/_app/_.forms.$formId'
import { Route as AppContactsImportRouteImport } from './routes/_app/_.contacts.import'
import { Route as AppContactsContactIdRouteImport } from './routes/_app/_.contacts.$contactId'
import { Route as AppCampaignsNewRouteImport } from './routes/_app/_.campaigns.new'
import { Route as AppCampaignsGoalIdRouteImport } from './routes/_app/_.campaigns.$goalId'
import { Route as AppCallTimeResultsRouteImport } from './routes/_app/_.call-time.results'
import { Route as AppCallTimeManageRouteImport } from './routes/_app/_.call-time.manage'
import { Route as AppBallotAccessDriveIdRouteImport } from './routes/_app/_.ballot-access.$driveId'
import { Route as AppActionGroupsSuggestionsRouteImport } from './routes/_app/_.action-groups.suggestions'
import { Route as AppActionGroupsAlertsRouteImport } from './routes/_app/_.action-groups.alerts'
import { Route as AppActionGroupsGroupIdRouteImport } from './routes/_app/_.action-groups.$groupId'
import { Route as AppPhoneBankingCampaignIdIndexRouteImport } from './routes/_app/_.phone-banking.$campaignId.index'
import { Route as AppPhoneBankingCampaignIdCallRouteImport } from './routes/_app/_.phone-banking.$campaignId.call'
import { Route as AppFundraisingDonorsDonorIdRouteImport } from './routes/_app/_.fundraising.donors.$donorId'
import { Route as AppContactsVoterFileL2VoterIdRouteImport } from './routes/_app/_.contacts.voter-file.$l2VoterId'
import { Route as AppContactsTextBankingNewRouteImport } from './routes/_app/_.contacts.text-banking.new'
import { Route as AppContactsTextBankingCampaignIdRouteImport } from './routes/_app/_.contacts.text-banking.$campaignId'
import { Route as AppContactsPhoneBankingCampaignIdRouteImport } from './routes/_app/_.contacts.phone-banking.$campaignId'
import { Route as AppContactsEmailNewRouteImport } from './routes/_app/_.contacts.email.new'
import { Route as AppContactsEmailEmailIdRouteImport } from './routes/_app/_.contacts.email.$emailId'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformIntroRoute = PlatformIntroRouteImport.update({
  id: '/platform-intro',
  path: '/platform-intro',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const StrategyMagicLinkRoute = StrategyMagicLinkRouteImport.update({
  id: '/strategy/magic-link',
  path: '/strategy/magic-link',
  getParentRoute: () => rootRouteImport,
} as any)
const DonateSlugRoute = DonateSlugRouteImport.update({
  id: '/donate/$slug',
  path: '/donate/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutSuccessRoute = CheckoutSuccessRouteImport.update({
  id: '/checkout/success',
  path: '/checkout/success',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutTokenRoute = CheckoutTokenRouteImport.update({
  id: '/checkout/$token',
  path: '/checkout/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutSuccessTokenRoute = CheckoutSuccessTokenRouteImport.update({
  id: '/checkout-success/$token',
  path: '/checkout-success/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: '/auth/verify-email',
  path: '/auth/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyRoute = AuthVerifyRouteImport.update({
  id: '/auth/verify',
  path: '/auth/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRegisterInviteRoute = AuthRegisterInviteRouteImport.update({
  id: '/auth/register-invite',
  path: '/auth/register-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthPhoneVerificationRoute = AuthPhoneVerificationRouteImport.update({
  id: '/auth/phone-verification',
  path: '/auth/phone-verification',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthGoogleCallbackRoute = AuthGoogleCallbackRouteImport.update({
  id: '/auth/google-callback',
  path: '/auth/google-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCreatePasswordRoute = AuthCreatePasswordRouteImport.update({
  id: '/auth/create-password',
  path: '/auth/create-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAcceptInviteRoute = AuthAcceptInviteRouteImport.update({
  id: '/auth/accept-invite',
  path: '/auth/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSplatRoute = AdminSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AdminRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/_auth/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthPendingApprovalRoute = AuthPendingApprovalRouteImport.update({
  id: '/_auth/pending-approval',
  path: '/pending-approval',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/_auth/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/_settings',
  getParentRoute: () => AppRoute,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/_/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AuthLoginGoogleCallbackRoute = AuthLoginGoogleCallbackRouteImport.update({
  id: '/google-callback',
  path: '/google-callback',
  getParentRoute: () => AuthLoginRoute,
} as any)
const AppSettingsTeamRoute = AppSettingsTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSettingsRoute = AppSettingsSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsFundraisingSettingsRoute =
  AppSettingsFundraisingSettingsRouteImport.update({
    id: '/fundraising-settings',
    path: '/fundraising-settings',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsEmailSettingsRoute =
  AppSettingsEmailSettingsRouteImport.update({
    id: '/email-settings',
    path: '/email-settings',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsBillingRoute = AppSettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppYourVotersRoute = AppYourVotersRouteImport.update({
  id: '/_/your-voters',
  path: '/your-voters',
  getParentRoute: () => AppRoute,
} as any)
const AppVoterFileStatsRoute = AppVoterFileStatsRouteImport.update({
  id: '/_/voter-file-stats',
  path: '/voter-file-stats',
  getParentRoute: () => AppRoute,
} as any)
const AppVolunteersRoute = AppVolunteersRouteImport.update({
  id: '/_/volunteers',
  path: '/volunteers',
  getParentRoute: () => AppRoute,
} as any)
const AppTextBankingRoute = AppTextBankingRouteImport.update({
  id: '/_/text-banking',
  path: '/text-banking',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksRoute = AppTasksRouteImport.update({
  id: '/_/tasks',
  path: '/tasks',
  getParentRoute: () => AppRoute,
} as any)
const AppStrategyRoute = AppStrategyRouteImport.update({
  id: '/_/strategy',
  path: '/strategy',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/_/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppPhoneBankingRoute = AppPhoneBankingRouteImport.update({
  id: '/_/phone-banking',
  path: '/phone-banking',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingRoute = AppOnboardingRouteImport.update({
  id: '/_/onboarding',
  path: '/onboarding',
  getParentRoute: () => AppRoute,
} as any)
const AppInterviewRoute = AppInterviewRouteImport.update({
  id: '/_/interview',
  path: '/interview',
  getParentRoute: () => AppRoute,
} as any)
const AppFundraisingRoute = AppFundraisingRouteImport.update({
  id: '/_/fundraising',
  path: '/fundraising',
  getParentRoute: () => AppRoute,
} as any)
const AppFormsRoute = AppFormsRouteImport.update({
  id: '/_/forms',
  path: '/forms',
  getParentRoute: () => AppRoute,
} as any)
const AppEmailRoute = AppEmailRouteImport.update({
  id: '/_/email',
  path: '/email',
  getParentRoute: () => AppRoute,
} as any)
const AppDailyBriefingRoute = AppDailyBriefingRouteImport.update({
  id: '/_/daily-briefing',
  path: '/daily-briefing',
  getParentRoute: () => AppRoute,
} as any)
const AppContactsRoute = AppContactsRouteImport.update({
  id: '/_/contacts',
  path: '/contacts',
  getParentRoute: () => AppRoute,
} as any)
const AppCommandCenterRoute = AppCommandCenterRouteImport.update({
  id: '/_/command-center',
  path: '/command-center',
  getParentRoute: () => AppRoute,
} as any)
const AppCallTimeRoute = AppCallTimeRouteImport.update({
  id: '/_/call-time',
  path: '/call-time',
  getParentRoute: () => AppRoute,
} as any)
const AppBallotAccessRoute = AppBallotAccessRouteImport.update({
  id: '/_/ballot-access',
  path: '/ballot-access',
  getParentRoute: () => AppRoute,
} as any)
const AppActionGroupsRoute = AppActionGroupsRouteImport.update({
  id: '/_/action-groups',
  path: '/action-groups',
  getParentRoute: () => AppRoute,
} as any)
const AppVoterFileStatsIndexRoute = AppVoterFileStatsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppVoterFileStatsRoute,
} as any)
const AppVolunteersIndexRoute = AppVolunteersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppVolunteersRoute,
} as any)
const AppTextBankingIndexRoute = AppTextBankingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTextBankingRoute,
} as any)
const AppTasksIndexRoute = AppTasksIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTasksRoute,
} as any)
const AppStrategyIndexRoute = AppStrategyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppStrategyRoute,
} as any)
const AppPhoneBankingIndexRoute = AppPhoneBankingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPhoneBankingRoute,
} as any)
const AppOutreachIndexRoute = AppOutreachIndexRouteImport.update({
  id: '/_/outreach/',
  path: '/outreach/',
  getParentRoute: () => AppRoute,
} as any)
const AppFundraisingIndexRoute = AppFundraisingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppFundraisingRoute,
} as any)
const AppFormsIndexRoute = AppFormsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppFormsRoute,
} as any)
const AppEmailIndexRoute = AppEmailIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppEmailRoute,
} as any)
const AppDailyBriefingIndexRoute = AppDailyBriefingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDailyBriefingRoute,
} as any)
const AppContactsIndexRoute = AppContactsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppContactsRoute,
} as any)
const AppCampaignsIndexRoute = AppCampaignsIndexRouteImport.update({
  id: '/_/campaigns/',
  path: '/campaigns/',
  getParentRoute: () => AppRoute,
} as any)
const AppCallTimeIndexRoute = AppCallTimeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCallTimeRoute,
} as any)
const AppBallotAccessIndexRoute = AppBallotAccessIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppBallotAccessRoute,
} as any)
const AppActionGroupsIndexRoute = AppActionGroupsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppActionGroupsRoute,
} as any)
const AppVolunteersVolunteerIdRoute =
  AppVolunteersVolunteerIdRouteImport.update({
    id: '/$volunteerId',
    path: '/$volunteerId',
    getParentRoute: () => AppVolunteersRoute,
  } as any)
const AppTextBankingNewRoute = AppTextBankingNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppTextBankingRoute,
} as any)
const AppTextBankingCampaignIdRoute =
  AppTextBankingCampaignIdRouteImport.update({
    id: '/$campaignId',
    path: '/$campaignId',
    getParentRoute: () => AppTextBankingRoute,
  } as any)
const AppStrategyVersionsRoute = AppStrategyVersionsRouteImport.update({
  id: '/versions',
  path: '/versions',
  getParentRoute: () => AppStrategyRoute,
} as any)
const AppStrategyRoadmapRoute = AppStrategyRoadmapRouteImport.update({
  id: '/roadmap',
  path: '/roadmap',
  getParentRoute: () => AppStrategyRoute,
} as any)
const AppStrategyRevealRoute = AppStrategyRevealRouteImport.update({
  id: '/reveal',
  path: '/reveal',
  getParentRoute: () => AppStrategyRoute,
} as any)
const AppStrategyQaRoute = AppStrategyQaRouteImport.update({
  id: '/qa',
  path: '/qa',
  getParentRoute: () => AppStrategyRoute,
} as any)
const AppStrategyDashboardRoute = AppStrategyDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppStrategyRoute,
} as any)
const AppStrategyBriefRoute = AppStrategyBriefRouteImport.update({
  id: '/brief',
  path: '/brief',
  getParentRoute: () => AppStrategyRoute,
} as any)
const AppPhoneBankingNewRoute = AppPhoneBankingNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppPhoneBankingRoute,
} as any)
const AppPhoneBankingCampaignIdRoute =
  AppPhoneBankingCampaignIdRouteImport.update({
    id: '/$campaignId',
    path: '/$campaignId',
    getParentRoute: () => AppPhoneBankingRoute,
  } as any)
const AppOutreachNewRoute = AppOutreachNewRouteImport.update({
  id: '/_/outreach/new',
  path: '/outreach/new',
  getParentRoute: () => AppRoute,
} as any)
const AppOutreachGroupAudiencesRoute =
  AppOutreachGroupAudiencesRouteImport.update({
    id: '/_/outreach/group-audiences',
    path: '/outreach/group-audiences',
    getParentRoute: () => AppRoute,
  } as any)
const AppOutreachAudiencesRoute = AppOutreachAudiencesRouteImport.update({
  id: '/_/outreach/audiences',
  path: '/outreach/audiences',
  getParentRoute: () => AppRoute,
} as any)
const AppOutreachOcIdRoute = AppOutreachOcIdRouteImport.update({
  id: '/_/outreach/$ocId',
  path: '/outreach/$ocId',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingMicSetupRoute = AppOnboardingMicSetupRouteImport.update({
  id: '/mic-setup',
  path: '/mic-setup',
  getParentRoute: () => AppOnboardingRoute,
} as any)
const AppOnboardingInterviewIntroRoute =
  AppOnboardingInterviewIntroRouteImport.update({
    id: '/interview-intro',
    path: '/interview-intro',
    getParentRoute: () => AppOnboardingRoute,
  } as any)
const AppOnboardingInterviewFollowUpRoute =
  AppOnboardingInterviewFollowUpRouteImport.update({
    id: '/interview-follow-up',
    path: '/interview-follow-up',
    getParentRoute: () => AppOnboardingRoute,
  } as any)
const AppOnboardingGetStartedRoute = AppOnboardingGetStartedRouteImport.update({
  id: '/get-started',
  path: '/get-started',
  getParentRoute: () => AppOnboardingRoute,
} as any)
const AppOnboardingGeneratingRoute = AppOnboardingGeneratingRouteImport.update({
  id: '/generating',
  path: '/generating',
  getParentRoute: () => AppOnboardingRoute,
} as any)
const AppOnboardingAcceptTosRoute = AppOnboardingAcceptTosRouteImport.update({
  id: '/accept-tos',
  path: '/accept-tos',
  getParentRoute: () => AppOnboardingRoute,
} as any)
const AppInterviewSessionRoute = AppInterviewSessionRouteImport.update({
  id: '/session',
  path: '/session',
  getParentRoute: () => AppInterviewRoute,
} as any)
const AppFundraisingSetupRoute = AppFundraisingSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => AppFundraisingRoute,
} as any)
const AppFundraisingSettingsRoute = AppFundraisingSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppFundraisingRoute,
} as any)
const AppFundraisingPageBuilderRoute =
  AppFundraisingPageBuilderRouteImport.update({
    id: '/page-builder',
    path: '/page-builder',
    getParentRoute: () => AppFundraisingRoute,
  } as any)
const AppFundraisingDonationsRoute = AppFundraisingDonationsRouteImport.update({
  id: '/donations',
  path: '/donations',
  getParentRoute: () => AppFundraisingRoute,
} as any)
const AppFundraisingComplianceRoute =
  AppFundraisingComplianceRouteImport.update({
    id: '/compliance',
    path: '/compliance',
    getParentRoute: () => AppFundraisingRoute,
  } as any)
const AppFormsNewRoute = AppFormsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppFormsRoute,
} as any)
const AppFormsFormIdRoute = AppFormsFormIdRouteImport.update({
  id: '/$formId',
  path: '/$formId',
  getParentRoute: () => AppFormsRoute,
} as any)
const AppContactsImportRoute = AppContactsImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => AppContactsRoute,
} as any)
const AppContactsContactIdRoute = AppContactsContactIdRouteImport.update({
  id: '/$contactId',
  path: '/$contactId',
  getParentRoute: () => AppContactsRoute,
} as any)
const AppCampaignsNewRoute = AppCampaignsNewRouteImport.update({
  id: '/_/campaigns/new',
  path: '/campaigns/new',
  getParentRoute: () => AppRoute,
} as any)
const AppCampaignsGoalIdRoute = AppCampaignsGoalIdRouteImport.update({
  id: '/_/campaigns/$goalId',
  path: '/campaigns/$goalId',
  getParentRoute: () => AppRoute,
} as any)
const AppCallTimeResultsRoute = AppCallTimeResultsRouteImport.update({
  id: '/results',
  path: '/results',
  getParentRoute: () => AppCallTimeRoute,
} as any)
const AppCallTimeManageRoute = AppCallTimeManageRouteImport.update({
  id: '/manage',
  path: '/manage',
  getParentRoute: () => AppCallTimeRoute,
} as any)
const AppBallotAccessDriveIdRoute = AppBallotAccessDriveIdRouteImport.update({
  id: '/$driveId',
  path: '/$driveId',
  getParentRoute: () => AppBallotAccessRoute,
} as any)
const AppActionGroupsSuggestionsRoute =
  AppActionGroupsSuggestionsRouteImport.update({
    id: '/suggestions',
    path: '/suggestions',
    getParentRoute: () => AppActionGroupsRoute,
  } as any)
const AppActionGroupsAlertsRoute = AppActionGroupsAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => AppActionGroupsRoute,
} as any)
const AppActionGroupsGroupIdRoute = AppActionGroupsGroupIdRouteImport.update({
  id: '/$groupId',
  path: '/$groupId',
  getParentRoute: () => AppActionGroupsRoute,
} as any)
const AppPhoneBankingCampaignIdIndexRoute =
  AppPhoneBankingCampaignIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppPhoneBankingCampaignIdRoute,
  } as any)
const AppPhoneBankingCampaignIdCallRoute =
  AppPhoneBankingCampaignIdCallRouteImport.update({
    id: '/call',
    path: '/call',
    getParentRoute: () => AppPhoneBankingCampaignIdRoute,
  } as any)
const AppFundraisingDonorsDonorIdRoute =
  AppFundraisingDonorsDonorIdRouteImport.update({
    id: '/donors/$donorId',
    path: '/donors/$donorId',
    getParentRoute: () => AppFundraisingRoute,
  } as any)
const AppContactsVoterFileL2VoterIdRoute =
  AppContactsVoterFileL2VoterIdRouteImport.update({
    id: '/voter-file/$l2VoterId',
    path: '/voter-file/$l2VoterId',
    getParentRoute: () => AppContactsRoute,
  } as any)
const AppContactsTextBankingNewRoute =
  AppContactsTextBankingNewRouteImport.update({
    id: '/text-banking/new',
    path: '/text-banking/new',
    getParentRoute: () => AppContactsRoute,
  } as any)
const AppContactsTextBankingCampaignIdRoute =
  AppContactsTextBankingCampaignIdRouteImport.update({
    id: '/text-banking/$campaignId',
    path: '/text-banking/$campaignId',
    getParentRoute: () => AppContactsRoute,
  } as any)
const AppContactsPhoneBankingCampaignIdRoute =
  AppContactsPhoneBankingCampaignIdRouteImport.update({
    id: '/phone-banking/$campaignId',
    path: '/phone-banking/$campaignId',
    getParentRoute: () => AppContactsRoute,
  } as any)
const AppContactsEmailNewRoute = AppContactsEmailNewRouteImport.update({
  id: '/email/new',
  path: '/email/new',
  getParentRoute: () => AppContactsRoute,
} as any)
const AppContactsEmailEmailIdRoute = AppContactsEmailEmailIdRouteImport.update({
  id: '/email/$emailId',
  path: '/email/$emailId',
  getParentRoute: () => AppContactsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/admin': typeof AdminRouteWithChildren
  '/platform-intro': typeof PlatformIntroRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/login': typeof AuthLoginRouteWithChildren
  '/pending-approval': typeof AuthPendingApprovalRoute
  '/signup': typeof AuthSignupRoute
  '/admin/$': typeof AdminSplatRoute
  '/auth/accept-invite': typeof AuthAcceptInviteRoute
  '/auth/create-password': typeof AuthCreatePasswordRoute
  '/auth/google-callback': typeof AuthGoogleCallbackRoute
  '/auth/phone-verification': typeof AuthPhoneVerificationRoute
  '/auth/register-invite': typeof AuthRegisterInviteRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/checkout-success/$token': typeof CheckoutSuccessTokenRoute
  '/checkout/$token': typeof CheckoutTokenRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/donate/$slug': typeof DonateSlugRoute
  '/strategy/magic-link': typeof StrategyMagicLinkRoute
  '/action-groups': typeof AppActionGroupsRouteWithChildren
  '/ballot-access': typeof AppBallotAccessRouteWithChildren
  '/call-time': typeof AppCallTimeRouteWithChildren
  '/command-center': typeof AppCommandCenterRoute
  '/contacts': typeof AppContactsRouteWithChildren
  '/daily-briefing': typeof AppDailyBriefingRouteWithChildren
  '/email': typeof AppEmailRouteWithChildren
  '/forms': typeof AppFormsRouteWithChildren
  '/fundraising': typeof AppFundraisingRouteWithChildren
  '/interview': typeof AppInterviewRouteWithChildren
  '/onboarding': typeof AppOnboardingRouteWithChildren
  '/phone-banking': typeof AppPhoneBankingRouteWithChildren
  '/profile': typeof AppProfileRoute
  '/strategy': typeof AppStrategyRouteWithChildren
  '/tasks': typeof AppTasksRouteWithChildren
  '/text-banking': typeof AppTextBankingRouteWithChildren
  '/volunteers': typeof AppVolunteersRouteWithChildren
  '/voter-file-stats': typeof AppVoterFileStatsRouteWithChildren
  '/your-voters': typeof AppYourVotersRoute
  '/billing': typeof AppSettingsBillingRoute
  '/email-settings': typeof AppSettingsEmailSettingsRoute
  '/fundraising-settings': typeof AppSettingsFundraisingSettingsRoute
  '/settings': typeof AppSettingsSettingsRoute
  '/team': typeof AppSettingsTeamRoute
  '/login/google-callback': typeof AuthLoginGoogleCallbackRoute
  '/': typeof AppIndexRoute
  '/action-groups/$groupId': typeof AppActionGroupsGroupIdRoute
  '/action-groups/alerts': typeof AppActionGroupsAlertsRoute
  '/action-groups/suggestions': typeof AppActionGroupsSuggestionsRoute
  '/ballot-access/$driveId': typeof AppBallotAccessDriveIdRoute
  '/call-time/manage': typeof AppCallTimeManageRoute
  '/call-time/results': typeof AppCallTimeResultsRoute
  '/campaigns/$goalId': typeof AppCampaignsGoalIdRoute
  '/campaigns/new': typeof AppCampaignsNewRoute
  '/contacts/$contactId': typeof AppContactsContactIdRoute
  '/contacts/import': typeof AppContactsImportRoute
  '/forms/$formId': typeof AppFormsFormIdRoute
  '/forms/new': typeof AppFormsNewRoute
  '/fundraising/compliance': typeof AppFundraisingComplianceRoute
  '/fundraising/donations': typeof AppFundraisingDonationsRoute
  '/fundraising/page-builder': typeof AppFundraisingPageBuilderRoute
  '/fundraising/settings': typeof AppFundraisingSettingsRoute
  '/fundraising/setup': typeof AppFundraisingSetupRoute
  '/interview/session': typeof AppInterviewSessionRoute
  '/onboarding/accept-tos': typeof AppOnboardingAcceptTosRoute
  '/onboarding/generating': typeof AppOnboardingGeneratingRoute
  '/onboarding/get-started': typeof AppOnboardingGetStartedRoute
  '/onboarding/interview-follow-up': typeof AppOnboardingInterviewFollowUpRoute
  '/onboarding/interview-intro': typeof AppOnboardingInterviewIntroRoute
  '/onboarding/mic-setup': typeof AppOnboardingMicSetupRoute
  '/outreach/$ocId': typeof AppOutreachOcIdRoute
  '/outreach/audiences': typeof AppOutreachAudiencesRoute
  '/outreach/group-audiences': typeof AppOutreachGroupAudiencesRoute
  '/outreach/new': typeof AppOutreachNewRoute
  '/phone-banking/$campaignId': typeof AppPhoneBankingCampaignIdRouteWithChildren
  '/phone-banking/new': typeof AppPhoneBankingNewRoute
  '/strategy/brief': typeof AppStrategyBriefRoute
  '/strategy/dashboard': typeof AppStrategyDashboardRoute
  '/strategy/qa': typeof AppStrategyQaRoute
  '/strategy/reveal': typeof AppStrategyRevealRoute
  '/strategy/roadmap': typeof AppStrategyRoadmapRoute
  '/strategy/versions': typeof AppStrategyVersionsRoute
  '/text-banking/$campaignId': typeof AppTextBankingCampaignIdRoute
  '/text-banking/new': typeof AppTextBankingNewRoute
  '/volunteers/$volunteerId': typeof AppVolunteersVolunteerIdRoute
  '/action-groups/': typeof AppActionGroupsIndexRoute
  '/ballot-access/': typeof AppBallotAccessIndexRoute
  '/call-time/': typeof AppCallTimeIndexRoute
  '/campaigns': typeof AppCampaignsIndexRoute
  '/contacts/': typeof AppContactsIndexRoute
  '/daily-briefing/': typeof AppDailyBriefingIndexRoute
  '/email/': typeof AppEmailIndexRoute
  '/forms/': typeof AppFormsIndexRoute
  '/fundraising/': typeof AppFundraisingIndexRoute
  '/outreach': typeof AppOutreachIndexRoute
  '/phone-banking/': typeof AppPhoneBankingIndexRoute
  '/strategy/': typeof AppStrategyIndexRoute
  '/tasks/': typeof AppTasksIndexRoute
  '/text-banking/': typeof AppTextBankingIndexRoute
  '/volunteers/': typeof AppVolunteersIndexRoute
  '/voter-file-stats/': typeof AppVoterFileStatsIndexRoute
  '/contacts/email/$emailId': typeof AppContactsEmailEmailIdRoute
  '/contacts/email/new': typeof AppContactsEmailNewRoute
  '/contacts/phone-banking/$campaignId': typeof AppContactsPhoneBankingCampaignIdRoute
  '/contacts/text-banking/$campaignId': typeof AppContactsTextBankingCampaignIdRoute
  '/contacts/text-banking/new': typeof AppContactsTextBankingNewRoute
  '/contacts/voter-file/$l2VoterId': typeof AppContactsVoterFileL2VoterIdRoute
  '/fundraising/donors/$donorId': typeof AppFundraisingDonorsDonorIdRoute
  '/phone-banking/$campaignId/call': typeof AppPhoneBankingCampaignIdCallRoute
  '/phone-banking/$campaignId/': typeof AppPhoneBankingCampaignIdIndexRoute
}
export interface FileRoutesByTo {
  '/admin': typeof AdminRouteWithChildren
  '/platform-intro': typeof PlatformIntroRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/login': typeof AuthLoginRouteWithChildren
  '/pending-approval': typeof AuthPendingApprovalRoute
  '/signup': typeof AuthSignupRoute
  '/admin/$': typeof AdminSplatRoute
  '/auth/accept-invite': typeof AuthAcceptInviteRoute
  '/auth/create-password': typeof AuthCreatePasswordRoute
  '/auth/google-callback': typeof AuthGoogleCallbackRoute
  '/auth/phone-verification': typeof AuthPhoneVerificationRoute
  '/auth/register-invite': typeof AuthRegisterInviteRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/checkout-success/$token': typeof CheckoutSuccessTokenRoute
  '/checkout/$token': typeof CheckoutTokenRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/donate/$slug': typeof DonateSlugRoute
  '/strategy/magic-link': typeof StrategyMagicLinkRoute
  '/command-center': typeof AppCommandCenterRoute
  '/interview': typeof AppInterviewRouteWithChildren
  '/onboarding': typeof AppOnboardingRouteWithChildren
  '/profile': typeof AppProfileRoute
  '/your-voters': typeof AppYourVotersRoute
  '/billing': typeof AppSettingsBillingRoute
  '/email-settings': typeof AppSettingsEmailSettingsRoute
  '/fundraising-settings': typeof AppSettingsFundraisingSettingsRoute
  '/settings': typeof AppSettingsSettingsRoute
  '/team': typeof AppSettingsTeamRoute
  '/login/google-callback': typeof AuthLoginGoogleCallbackRoute
  '/': typeof AppIndexRoute
  '/action-groups/$groupId': typeof AppActionGroupsGroupIdRoute
  '/action-groups/alerts': typeof AppActionGroupsAlertsRoute
  '/action-groups/suggestions': typeof AppActionGroupsSuggestionsRoute
  '/ballot-access/$driveId': typeof AppBallotAccessDriveIdRoute
  '/call-time/manage': typeof AppCallTimeManageRoute
  '/call-time/results': typeof AppCallTimeResultsRoute
  '/campaigns/$goalId': typeof AppCampaignsGoalIdRoute
  '/campaigns/new': typeof AppCampaignsNewRoute
  '/contacts/$contactId': typeof AppContactsContactIdRoute
  '/contacts/import': typeof AppContactsImportRoute
  '/forms/$formId': typeof AppFormsFormIdRoute
  '/forms/new': typeof AppFormsNewRoute
  '/fundraising/compliance': typeof AppFundraisingComplianceRoute
  '/fundraising/donations': typeof AppFundraisingDonationsRoute
  '/fundraising/page-builder': typeof AppFundraisingPageBuilderRoute
  '/fundraising/settings': typeof AppFundraisingSettingsRoute
  '/fundraising/setup': typeof AppFundraisingSetupRoute
  '/interview/session': typeof AppInterviewSessionRoute
  '/onboarding/accept-tos': typeof AppOnboardingAcceptTosRoute
  '/onboarding/generating': typeof AppOnboardingGeneratingRoute
  '/onboarding/get-started': typeof AppOnboardingGetStartedRoute
  '/onboarding/interview-follow-up': typeof AppOnboardingInterviewFollowUpRoute
  '/onboarding/interview-intro': typeof AppOnboardingInterviewIntroRoute
  '/onboarding/mic-setup': typeof AppOnboardingMicSetupRoute
  '/outreach/$ocId': typeof AppOutreachOcIdRoute
  '/outreach/audiences': typeof AppOutreachAudiencesRoute
  '/outreach/group-audiences': typeof AppOutreachGroupAudiencesRoute
  '/outreach/new': typeof AppOutreachNewRoute
  '/phone-banking/new': typeof AppPhoneBankingNewRoute
  '/strategy/brief': typeof AppStrategyBriefRoute
  '/strategy/dashboard': typeof AppStrategyDashboardRoute
  '/strategy/qa': typeof AppStrategyQaRoute
  '/strategy/reveal': typeof AppStrategyRevealRoute
  '/strategy/roadmap': typeof AppStrategyRoadmapRoute
  '/strategy/versions': typeof AppStrategyVersionsRoute
  '/text-banking/$campaignId': typeof AppTextBankingCampaignIdRoute
  '/text-banking/new': typeof AppTextBankingNewRoute
  '/volunteers/$volunteerId': typeof AppVolunteersVolunteerIdRoute
  '/action-groups': typeof AppActionGroupsIndexRoute
  '/ballot-access': typeof AppBallotAccessIndexRoute
  '/call-time': typeof AppCallTimeIndexRoute
  '/campaigns': typeof AppCampaignsIndexRoute
  '/contacts': typeof AppContactsIndexRoute
  '/daily-briefing': typeof AppDailyBriefingIndexRoute
  '/email': typeof AppEmailIndexRoute
  '/forms': typeof AppFormsIndexRoute
  '/fundraising': typeof AppFundraisingIndexRoute
  '/outreach': typeof AppOutreachIndexRoute
  '/phone-banking': typeof AppPhoneBankingIndexRoute
  '/strategy': typeof AppStrategyIndexRoute
  '/tasks': typeof AppTasksIndexRoute
  '/text-banking': typeof AppTextBankingIndexRoute
  '/volunteers': typeof AppVolunteersIndexRoute
  '/voter-file-stats': typeof AppVoterFileStatsIndexRoute
  '/contacts/email/$emailId': typeof AppContactsEmailEmailIdRoute
  '/contacts/email/new': typeof AppContactsEmailNewRoute
  '/contacts/phone-banking/$campaignId': typeof AppContactsPhoneBankingCampaignIdRoute
  '/contacts/text-banking/$campaignId': typeof AppContactsTextBankingCampaignIdRoute
  '/contacts/text-banking/new': typeof AppContactsTextBankingNewRoute
  '/contacts/voter-file/$l2VoterId': typeof AppContactsVoterFileL2VoterIdRoute
  '/fundraising/donors/$donorId': typeof AppFundraisingDonorsDonorIdRoute
  '/phone-banking/$campaignId/call': typeof AppPhoneBankingCampaignIdCallRoute
  '/phone-banking/$campaignId': typeof AppPhoneBankingCampaignIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/platform-intro': typeof PlatformIntroRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/_app/_settings': typeof AppSettingsRouteWithChildren
  '/_auth/login': typeof AuthLoginRouteWithChildren
  '/_auth/pending-approval': typeof AuthPendingApprovalRoute
  '/_auth/signup': typeof AuthSignupRoute
  '/admin/$': typeof AdminSplatRoute
  '/auth/accept-invite': typeof AuthAcceptInviteRoute
  '/auth/create-password': typeof AuthCreatePasswordRoute
  '/auth/google-callback': typeof AuthGoogleCallbackRoute
  '/auth/phone-verification': typeof AuthPhoneVerificationRoute
  '/auth/register-invite': typeof AuthRegisterInviteRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/checkout-success/$token': typeof CheckoutSuccessTokenRoute
  '/checkout/$token': typeof CheckoutTokenRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/donate/$slug': typeof DonateSlugRoute
  '/strategy/magic-link': typeof StrategyMagicLinkRoute
  '/_app/_/action-groups': typeof AppActionGroupsRouteWithChildren
  '/_app/_/ballot-access': typeof AppBallotAccessRouteWithChildren
  '/_app/_/call-time': typeof AppCallTimeRouteWithChildren
  '/_app/_/command-center': typeof AppCommandCenterRoute
  '/_app/_/contacts': typeof AppContactsRouteWithChildren
  '/_app/_/daily-briefing': typeof AppDailyBriefingRouteWithChildren
  '/_app/_/email': typeof AppEmailRouteWithChildren
  '/_app/_/forms': typeof AppFormsRouteWithChildren
  '/_app/_/fundraising': typeof AppFundraisingRouteWithChildren
  '/_app/_/interview': typeof AppInterviewRouteWithChildren
  '/_app/_/onboarding': typeof AppOnboardingRouteWithChildren
  '/_app/_/phone-banking': typeof AppPhoneBankingRouteWithChildren
  '/_app/_/profile': typeof AppProfileRoute
  '/_app/_/strategy': typeof AppStrategyRouteWithChildren
  '/_app/_/tasks': typeof AppTasksRouteWithChildren
  '/_app/_/text-banking': typeof AppTextBankingRouteWithChildren
  '/_app/_/volunteers': typeof AppVolunteersRouteWithChildren
  '/_app/_/voter-file-stats': typeof AppVoterFileStatsRouteWithChildren
  '/_app/_/your-voters': typeof AppYourVotersRoute
  '/_app/_settings/billing': typeof AppSettingsBillingRoute
  '/_app/_settings/email-settings': typeof AppSettingsEmailSettingsRoute
  '/_app/_settings/fundraising-settings': typeof AppSettingsFundraisingSettingsRoute
  '/_app/_settings/settings': typeof AppSettingsSettingsRoute
  '/_app/_settings/team': typeof AppSettingsTeamRoute
  '/_auth/login/google-callback': typeof AuthLoginGoogleCallbackRoute
  '/_app/_/': typeof AppIndexRoute
  '/_app/_/action-groups/$groupId': typeof AppActionGroupsGroupIdRoute
  '/_app/_/action-groups/alerts': typeof AppActionGroupsAlertsRoute
  '/_app/_/action-groups/suggestions': typeof AppActionGroupsSuggestionsRoute
  '/_app/_/ballot-access/$driveId': typeof AppBallotAccessDriveIdRoute
  '/_app/_/call-time/manage': typeof AppCallTimeManageRoute
  '/_app/_/call-time/results': typeof AppCallTimeResultsRoute
  '/_app/_/campaigns/$goalId': typeof AppCampaignsGoalIdRoute
  '/_app/_/campaigns/new': typeof AppCampaignsNewRoute
  '/_app/_/contacts/$contactId': typeof AppContactsContactIdRoute
  '/_app/_/contacts/import': typeof AppContactsImportRoute
  '/_app/_/forms/$formId': typeof AppFormsFormIdRoute
  '/_app/_/forms/new': typeof AppFormsNewRoute
  '/_app/_/fundraising/compliance': typeof AppFundraisingComplianceRoute
  '/_app/_/fundraising/donations': typeof AppFundraisingDonationsRoute
  '/_app/_/fundraising/page-builder': typeof AppFundraisingPageBuilderRoute
  '/_app/_/fundraising/settings': typeof AppFundraisingSettingsRoute
  '/_app/_/fundraising/setup': typeof AppFundraisingSetupRoute
  '/_app/_/interview/session': typeof AppInterviewSessionRoute
  '/_app/_/onboarding/accept-tos': typeof AppOnboardingAcceptTosRoute
  '/_app/_/onboarding/generating': typeof AppOnboardingGeneratingRoute
  '/_app/_/onboarding/get-started': typeof AppOnboardingGetStartedRoute
  '/_app/_/onboarding/interview-follow-up': typeof AppOnboardingInterviewFollowUpRoute
  '/_app/_/onboarding/interview-intro': typeof AppOnboardingInterviewIntroRoute
  '/_app/_/onboarding/mic-setup': typeof AppOnboardingMicSetupRoute
  '/_app/_/outreach/$ocId': typeof AppOutreachOcIdRoute
  '/_app/_/outreach/audiences': typeof AppOutreachAudiencesRoute
  '/_app/_/outreach/group-audiences': typeof AppOutreachGroupAudiencesRoute
  '/_app/_/outreach/new': typeof AppOutreachNewRoute
  '/_app/_/phone-banking/$campaignId': typeof AppPhoneBankingCampaignIdRouteWithChildren
  '/_app/_/phone-banking/new': typeof AppPhoneBankingNewRoute
  '/_app/_/strategy/brief': typeof AppStrategyBriefRoute
  '/_app/_/strategy/dashboard': typeof AppStrategyDashboardRoute
  '/_app/_/strategy/qa': typeof AppStrategyQaRoute
  '/_app/_/strategy/reveal': typeof AppStrategyRevealRoute
  '/_app/_/strategy/roadmap': typeof AppStrategyRoadmapRoute
  '/_app/_/strategy/versions': typeof AppStrategyVersionsRoute
  '/_app/_/text-banking/$campaignId': typeof AppTextBankingCampaignIdRoute
  '/_app/_/text-banking/new': typeof AppTextBankingNewRoute
  '/_app/_/volunteers/$volunteerId': typeof AppVolunteersVolunteerIdRoute
  '/_app/_/action-groups/': typeof AppActionGroupsIndexRoute
  '/_app/_/ballot-access/': typeof AppBallotAccessIndexRoute
  '/_app/_/call-time/': typeof AppCallTimeIndexRoute
  '/_app/_/campaigns/': typeof AppCampaignsIndexRoute
  '/_app/_/contacts/': typeof AppContactsIndexRoute
  '/_app/_/daily-briefing/': typeof AppDailyBriefingIndexRoute
  '/_app/_/email/': typeof AppEmailIndexRoute
  '/_app/_/forms/': typeof AppFormsIndexRoute
  '/_app/_/fundraising/': typeof AppFundraisingIndexRoute
  '/_app/_/outreach/': typeof AppOutreachIndexRoute
  '/_app/_/phone-banking/': typeof AppPhoneBankingIndexRoute
  '/_app/_/strategy/': typeof AppStrategyIndexRoute
  '/_app/_/tasks/': typeof AppTasksIndexRoute
  '/_app/_/text-banking/': typeof AppTextBankingIndexRoute
  '/_app/_/volunteers/': typeof AppVolunteersIndexRoute
  '/_app/_/voter-file-stats/': typeof AppVoterFileStatsIndexRoute
  '/_app/_/contacts/email/$emailId': typeof AppContactsEmailEmailIdRoute
  '/_app/_/contacts/email/new': typeof AppContactsEmailNewRoute
  '/_app/_/contacts/phone-banking/$campaignId': typeof AppContactsPhoneBankingCampaignIdRoute
  '/_app/_/contacts/text-banking/$campaignId': typeof AppContactsTextBankingCampaignIdRoute
  '/_app/_/contacts/text-banking/new': typeof AppContactsTextBankingNewRoute
  '/_app/_/contacts/voter-file/$l2VoterId': typeof AppContactsVoterFileL2VoterIdRoute
  '/_app/_/fundraising/donors/$donorId': typeof AppFundraisingDonorsDonorIdRoute
  '/_app/_/phone-banking/$campaignId/call': typeof AppPhoneBankingCampaignIdCallRoute
  '/_app/_/phone-banking/$campaignId/': typeof AppPhoneBankingCampaignIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/admin'
    | '/platform-intro'
    | '/privacy'
    | '/terms'
    | '/login'
    | '/pending-approval'
    | '/signup'
    | '/admin/$'
    | '/auth/accept-invite'
    | '/auth/create-password'
    | '/auth/google-callback'
    | '/auth/phone-verification'
    | '/auth/register-invite'
    | '/auth/reset-password'
    | '/auth/verify'
    | '/auth/verify-email'
    | '/checkout-success/$token'
    | '/checkout/$token'
    | '/checkout/success'
    | '/donate/$slug'
    | '/strategy/magic-link'
    | '/action-groups'
    | '/ballot-access'
    | '/call-time'
    | '/command-center'
    | '/contacts'
    | '/daily-briefing'
    | '/email'
    | '/forms'
    | '/fundraising'
    | '/interview'
    | '/onboarding'
    | '/phone-banking'
    | '/profile'
    | '/strategy'
    | '/tasks'
    | '/text-banking'
    | '/volunteers'
    | '/voter-file-stats'
    | '/your-voters'
    | '/billing'
    | '/email-settings'
    | '/fundraising-settings'
    | '/settings'
    | '/team'
    | '/login/google-callback'
    | '/'
    | '/action-groups/$groupId'
    | '/action-groups/alerts'
    | '/action-groups/suggestions'
    | '/ballot-access/$driveId'
    | '/call-time/manage'
    | '/call-time/results'
    | '/campaigns/$goalId'
    | '/campaigns/new'
    | '/contacts/$contactId'
    | '/contacts/import'
    | '/forms/$formId'
    | '/forms/new'
    | '/fundraising/compliance'
    | '/fundraising/donations'
    | '/fundraising/page-builder'
    | '/fundraising/settings'
    | '/fundraising/setup'
    | '/interview/session'
    | '/onboarding/accept-tos'
    | '/onboarding/generating'
    | '/onboarding/get-started'
    | '/onboarding/interview-follow-up'
    | '/onboarding/interview-intro'
    | '/onboarding/mic-setup'
    | '/outreach/$ocId'
    | '/outreach/audiences'
    | '/outreach/group-audiences'
    | '/outreach/new'
    | '/phone-banking/$campaignId'
    | '/phone-banking/new'
    | '/strategy/brief'
    | '/strategy/dashboard'
    | '/strategy/qa'
    | '/strategy/reveal'
    | '/strategy/roadmap'
    | '/strategy/versions'
    | '/text-banking/$campaignId'
    | '/text-banking/new'
    | '/volunteers/$volunteerId'
    | '/action-groups/'
    | '/ballot-access/'
    | '/call-time/'
    | '/campaigns'
    | '/contacts/'
    | '/daily-briefing/'
    | '/email/'
    | '/forms/'
    | '/fundraising/'
    | '/outreach'
    | '/phone-banking/'
    | '/strategy/'
    | '/tasks/'
    | '/text-banking/'
    | '/volunteers/'
    | '/voter-file-stats/'
    | '/contacts/email/$emailId'
    | '/contacts/email/new'
    | '/contacts/phone-banking/$campaignId'
    | '/contacts/text-banking/$campaignId'
    | '/contacts/text-banking/new'
    | '/contacts/voter-file/$l2VoterId'
    | '/fundraising/donors/$donorId'
    | '/phone-banking/$campaignId/call'
    | '/phone-banking/$campaignId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/admin'
    | '/platform-intro'
    | '/privacy'
    | '/terms'
    | '/login'
    | '/pending-approval'
    | '/signup'
    | '/admin/$'
    | '/auth/accept-invite'
    | '/auth/create-password'
    | '/auth/google-callback'
    | '/auth/phone-verification'
    | '/auth/register-invite'
    | '/auth/reset-password'
    | '/auth/verify'
    | '/auth/verify-email'
    | '/checkout-success/$token'
    | '/checkout/$token'
    | '/checkout/success'
    | '/donate/$slug'
    | '/strategy/magic-link'
    | '/command-center'
    | '/interview'
    | '/onboarding'
    | '/profile'
    | '/your-voters'
    | '/billing'
    | '/email-settings'
    | '/fundraising-settings'
    | '/settings'
    | '/team'
    | '/login/google-callback'
    | '/'
    | '/action-groups/$groupId'
    | '/action-groups/alerts'
    | '/action-groups/suggestions'
    | '/ballot-access/$driveId'
    | '/call-time/manage'
    | '/call-time/results'
    | '/campaigns/$goalId'
    | '/campaigns/new'
    | '/contacts/$contactId'
    | '/contacts/import'
    | '/forms/$formId'
    | '/forms/new'
    | '/fundraising/compliance'
    | '/fundraising/donations'
    | '/fundraising/page-builder'
    | '/fundraising/settings'
    | '/fundraising/setup'
    | '/interview/session'
    | '/onboarding/accept-tos'
    | '/onboarding/generating'
    | '/onboarding/get-started'
    | '/onboarding/interview-follow-up'
    | '/onboarding/interview-intro'
    | '/onboarding/mic-setup'
    | '/outreach/$ocId'
    | '/outreach/audiences'
    | '/outreach/group-audiences'
    | '/outreach/new'
    | '/phone-banking/new'
    | '/strategy/brief'
    | '/strategy/dashboard'
    | '/strategy/qa'
    | '/strategy/reveal'
    | '/strategy/roadmap'
    | '/strategy/versions'
    | '/text-banking/$campaignId'
    | '/text-banking/new'
    | '/volunteers/$volunteerId'
    | '/action-groups'
    | '/ballot-access'
    | '/call-time'
    | '/campaigns'
    | '/contacts'
    | '/daily-briefing'
    | '/email'
    | '/forms'
    | '/fundraising'
    | '/outreach'
    | '/phone-banking'
    | '/strategy'
    | '/tasks'
    | '/text-banking'
    | '/volunteers'
    | '/voter-file-stats'
    | '/contacts/email/$emailId'
    | '/contacts/email/new'
    | '/contacts/phone-banking/$campaignId'
    | '/contacts/text-banking/$campaignId'
    | '/contacts/text-banking/new'
    | '/contacts/voter-file/$l2VoterId'
    | '/fundraising/donors/$donorId'
    | '/phone-banking/$campaignId/call'
    | '/phone-banking/$campaignId'
  id:
    | '__root__'
    | '/_app'
    | '/admin'
    | '/platform-intro'
    | '/privacy'
    | '/terms'
    | '/_app/_settings'
    | '/_auth/login'
    | '/_auth/pending-approval'
    | '/_auth/signup'
    | '/admin/$'
    | '/auth/accept-invite'
    | '/auth/create-password'
    | '/auth/google-callback'
    | '/auth/phone-verification'
    | '/auth/register-invite'
    | '/auth/reset-password'
    | '/auth/verify'
    | '/auth/verify-email'
    | '/checkout-success/$token'
    | '/checkout/$token'
    | '/checkout/success'
    | '/donate/$slug'
    | '/strategy/magic-link'
    | '/_app/_/action-groups'
    | '/_app/_/ballot-access'
    | '/_app/_/call-time'
    | '/_app/_/command-center'
    | '/_app/_/contacts'
    | '/_app/_/daily-briefing'
    | '/_app/_/email'
    | '/_app/_/forms'
    | '/_app/_/fundraising'
    | '/_app/_/interview'
    | '/_app/_/onboarding'
    | '/_app/_/phone-banking'
    | '/_app/_/profile'
    | '/_app/_/strategy'
    | '/_app/_/tasks'
    | '/_app/_/text-banking'
    | '/_app/_/volunteers'
    | '/_app/_/voter-file-stats'
    | '/_app/_/your-voters'
    | '/_app/_settings/billing'
    | '/_app/_settings/email-settings'
    | '/_app/_settings/fundraising-settings'
    | '/_app/_settings/settings'
    | '/_app/_settings/team'
    | '/_auth/login/google-callback'
    | '/_app/_/'
    | '/_app/_/action-groups/$groupId'
    | '/_app/_/action-groups/alerts'
    | '/_app/_/action-groups/suggestions'
    | '/_app/_/ballot-access/$driveId'
    | '/_app/_/call-time/manage'
    | '/_app/_/call-time/results'
    | '/_app/_/campaigns/$goalId'
    | '/_app/_/campaigns/new'
    | '/_app/_/contacts/$contactId'
    | '/_app/_/contacts/import'
    | '/_app/_/forms/$formId'
    | '/_app/_/forms/new'
    | '/_app/_/fundraising/compliance'
    | '/_app/_/fundraising/donations'
    | '/_app/_/fundraising/page-builder'
    | '/_app/_/fundraising/settings'
    | '/_app/_/fundraising/setup'
    | '/_app/_/interview/session'
    | '/_app/_/onboarding/accept-tos'
    | '/_app/_/onboarding/generating'
    | '/_app/_/onboarding/get-started'
    | '/_app/_/onboarding/interview-follow-up'
    | '/_app/_/onboarding/interview-intro'
    | '/_app/_/onboarding/mic-setup'
    | '/_app/_/outreach/$ocId'
    | '/_app/_/outreach/audiences'
    | '/_app/_/outreach/group-audiences'
    | '/_app/_/outreach/new'
    | '/_app/_/phone-banking/$campaignId'
    | '/_app/_/phone-banking/new'
    | '/_app/_/strategy/brief'
    | '/_app/_/strategy/dashboard'
    | '/_app/_/strategy/qa'
    | '/_app/_/strategy/reveal'
    | '/_app/_/strategy/roadmap'
    | '/_app/_/strategy/versions'
    | '/_app/_/text-banking/$campaignId'
    | '/_app/_/text-banking/new'
    | '/_app/_/volunteers/$volunteerId'
    | '/_app/_/action-groups/'
    | '/_app/_/ballot-access/'
    | '/_app/_/call-time/'
    | '/_app/_/campaigns/'
    | '/_app/_/contacts/'
    | '/_app/_/daily-briefing/'
    | '/_app/_/email/'
    | '/_app/_/forms/'
    | '/_app/_/fundraising/'
    | '/_app/_/outreach/'
    | '/_app/_/phone-banking/'
    | '/_app/_/strategy/'
    | '/_app/_/tasks/'
    | '/_app/_/text-banking/'
    | '/_app/_/volunteers/'
    | '/_app/_/voter-file-stats/'
    | '/_app/_/contacts/email/$emailId'
    | '/_app/_/contacts/email/new'
    | '/_app/_/contacts/phone-banking/$campaignId'
    | '/_app/_/contacts/text-banking/$campaignId'
    | '/_app/_/contacts/text-banking/new'
    | '/_app/_/contacts/voter-file/$l2VoterId'
    | '/_app/_/fundraising/donors/$donorId'
    | '/_app/_/phone-banking/$campaignId/call'
    | '/_app/_/phone-banking/$campaignId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AdminRoute: typeof AdminRouteWithChildren
  PlatformIntroRoute: typeof PlatformIntroRoute
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
  AuthLoginRoute: typeof AuthLoginRouteWithChildren
  AuthPendingApprovalRoute: typeof AuthPendingApprovalRoute
  AuthSignupRoute: typeof AuthSignupRoute
  AuthAcceptInviteRoute: typeof AuthAcceptInviteRoute
  AuthCreatePasswordRoute: typeof AuthCreatePasswordRoute
  AuthGoogleCallbackRoute: typeof AuthGoogleCallbackRoute
  AuthPhoneVerificationRoute: typeof AuthPhoneVerificationRoute
  AuthRegisterInviteRoute: typeof AuthRegisterInviteRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthVerifyRoute: typeof AuthVerifyRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
  CheckoutSuccessTokenRoute: typeof CheckoutSuccessTokenRoute
  CheckoutTokenRoute: typeof CheckoutTokenRoute
  CheckoutSuccessRoute: typeof CheckoutSuccessRoute
  DonateSlugRoute: typeof DonateSlugRoute
  StrategyMagicLinkRoute: typeof StrategyMagicLinkRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform-intro': {
      id: '/platform-intro'
      path: '/platform-intro'
      fullPath: '/platform-intro'
      preLoaderRoute: typeof PlatformIntroRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/strategy/magic-link': {
      id: '/strategy/magic-link'
      path: '/strategy/magic-link'
      fullPath: '/strategy/magic-link'
      preLoaderRoute: typeof StrategyMagicLinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/donate/$slug': {
      id: '/donate/$slug'
      path: '/donate/$slug'
      fullPath: '/donate/$slug'
      preLoaderRoute: typeof DonateSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/success': {
      id: '/checkout/success'
      path: '/checkout/success'
      fullPath: '/checkout/success'
      preLoaderRoute: typeof CheckoutSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/$token': {
      id: '/checkout/$token'
      path: '/checkout/$token'
      fullPath: '/checkout/$token'
      preLoaderRoute: typeof CheckoutTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout-success/$token': {
      id: '/checkout-success/$token'
      path: '/checkout-success/$token'
      fullPath: '/checkout-success/$token'
      preLoaderRoute: typeof CheckoutSuccessTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/verify-email': {
      id: '/auth/verify-email'
      path: '/auth/verify-email'
      fullPath: '/auth/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/verify': {
      id: '/auth/verify'
      path: '/auth/verify'
      fullPath: '/auth/verify'
      preLoaderRoute: typeof AuthVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/register-invite': {
      id: '/auth/register-invite'
      path: '/auth/register-invite'
      fullPath: '/auth/register-invite'
      preLoaderRoute: typeof AuthRegisterInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/phone-verification': {
      id: '/auth/phone-verification'
      path: '/auth/phone-verification'
      fullPath: '/auth/phone-verification'
      preLoaderRoute: typeof AuthPhoneVerificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/google-callback': {
      id: '/auth/google-callback'
      path: '/auth/google-callback'
      fullPath: '/auth/google-callback'
      preLoaderRoute: typeof AuthGoogleCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/create-password': {
      id: '/auth/create-password'
      path: '/auth/create-password'
      fullPath: '/auth/create-password'
      preLoaderRoute: typeof AuthCreatePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/accept-invite': {
      id: '/auth/accept-invite'
      path: '/auth/accept-invite'
      fullPath: '/auth/accept-invite'
      preLoaderRoute: typeof AuthAcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/$': {
      id: '/admin/$'
      path: '/$'
      fullPath: '/admin/$'
      preLoaderRoute: typeof AdminSplatRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_auth/signup': {
      id: '/_auth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/pending-approval': {
      id: '/_auth/pending-approval'
      path: '/pending-approval'
      fullPath: '/pending-approval'
      preLoaderRoute: typeof AuthPendingApprovalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/_settings': {
      id: '/_app/_settings'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/': {
      id: '/_app/_/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/login/google-callback': {
      id: '/_auth/login/google-callback'
      path: '/google-callback'
      fullPath: '/login/google-callback'
      preLoaderRoute: typeof AuthLoginGoogleCallbackRouteImport
      parentRoute: typeof AuthLoginRoute
    }
    '/_app/_settings/team': {
      id: '/_app/_settings/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AppSettingsTeamRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/_settings/settings': {
      id: '/_app/_settings/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsSettingsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/_settings/fundraising-settings': {
      id: '/_app/_settings/fundraising-settings'
      path: '/fundraising-settings'
      fullPath: '/fundraising-settings'
      preLoaderRoute: typeof AppSettingsFundraisingSettingsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/_settings/email-settings': {
      id: '/_app/_settings/email-settings'
      path: '/email-settings'
      fullPath: '/email-settings'
      preLoaderRoute: typeof AppSettingsEmailSettingsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/_settings/billing': {
      id: '/_app/_settings/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AppSettingsBillingRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/_/your-voters': {
      id: '/_app/_/your-voters'
      path: '/your-voters'
      fullPath: '/your-voters'
      preLoaderRoute: typeof AppYourVotersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/voter-file-stats': {
      id: '/_app/_/voter-file-stats'
      path: '/voter-file-stats'
      fullPath: '/voter-file-stats'
      preLoaderRoute: typeof AppVoterFileStatsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/volunteers': {
      id: '/_app/_/volunteers'
      path: '/volunteers'
      fullPath: '/volunteers'
      preLoaderRoute: typeof AppVolunteersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/text-banking': {
      id: '/_app/_/text-banking'
      path: '/text-banking'
      fullPath: '/text-banking'
      preLoaderRoute: typeof AppTextBankingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/tasks': {
      id: '/_app/_/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AppTasksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/strategy': {
      id: '/_app/_/strategy'
      path: '/strategy'
      fullPath: '/strategy'
      preLoaderRoute: typeof AppStrategyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/profile': {
      id: '/_app/_/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/phone-banking': {
      id: '/_app/_/phone-banking'
      path: '/phone-banking'
      fullPath: '/phone-banking'
      preLoaderRoute: typeof AppPhoneBankingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/onboarding': {
      id: '/_app/_/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AppOnboardingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/interview': {
      id: '/_app/_/interview'
      path: '/interview'
      fullPath: '/interview'
      preLoaderRoute: typeof AppInterviewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/fundraising': {
      id: '/_app/_/fundraising'
      path: '/fundraising'
      fullPath: '/fundraising'
      preLoaderRoute: typeof AppFundraisingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/forms': {
      id: '/_app/_/forms'
      path: '/forms'
      fullPath: '/forms'
      preLoaderRoute: typeof AppFormsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/email': {
      id: '/_app/_/email'
      path: '/email'
      fullPath: '/email'
      preLoaderRoute: typeof AppEmailRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/daily-briefing': {
      id: '/_app/_/daily-briefing'
      path: '/daily-briefing'
      fullPath: '/daily-briefing'
      preLoaderRoute: typeof AppDailyBriefingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/contacts': {
      id: '/_app/_/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof AppContactsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/command-center': {
      id: '/_app/_/command-center'
      path: '/command-center'
      fullPath: '/command-center'
      preLoaderRoute: typeof AppCommandCenterRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/call-time': {
      id: '/_app/_/call-time'
      path: '/call-time'
      fullPath: '/call-time'
      preLoaderRoute: typeof AppCallTimeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/ballot-access': {
      id: '/_app/_/ballot-access'
      path: '/ballot-access'
      fullPath: '/ballot-access'
      preLoaderRoute: typeof AppBallotAccessRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/action-groups': {
      id: '/_app/_/action-groups'
      path: '/action-groups'
      fullPath: '/action-groups'
      preLoaderRoute: typeof AppActionGroupsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/voter-file-stats/': {
      id: '/_app/_/voter-file-stats/'
      path: '/'
      fullPath: '/voter-file-stats/'
      preLoaderRoute: typeof AppVoterFileStatsIndexRouteImport
      parentRoute: typeof AppVoterFileStatsRoute
    }
    '/_app/_/volunteers/': {
      id: '/_app/_/volunteers/'
      path: '/'
      fullPath: '/volunteers/'
      preLoaderRoute: typeof AppVolunteersIndexRouteImport
      parentRoute: typeof AppVolunteersRoute
    }
    '/_app/_/text-banking/': {
      id: '/_app/_/text-banking/'
      path: '/'
      fullPath: '/text-banking/'
      preLoaderRoute: typeof AppTextBankingIndexRouteImport
      parentRoute: typeof AppTextBankingRoute
    }
    '/_app/_/tasks/': {
      id: '/_app/_/tasks/'
      path: '/'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AppTasksIndexRouteImport
      parentRoute: typeof AppTasksRoute
    }
    '/_app/_/strategy/': {
      id: '/_app/_/strategy/'
      path: '/'
      fullPath: '/strategy/'
      preLoaderRoute: typeof AppStrategyIndexRouteImport
      parentRoute: typeof AppStrategyRoute
    }
    '/_app/_/phone-banking/': {
      id: '/_app/_/phone-banking/'
      path: '/'
      fullPath: '/phone-banking/'
      preLoaderRoute: typeof AppPhoneBankingIndexRouteImport
      parentRoute: typeof AppPhoneBankingRoute
    }
    '/_app/_/outreach/': {
      id: '/_app/_/outreach/'
      path: '/outreach'
      fullPath: '/outreach'
      preLoaderRoute: typeof AppOutreachIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/fundraising/': {
      id: '/_app/_/fundraising/'
      path: '/'
      fullPath: '/fundraising/'
      preLoaderRoute: typeof AppFundraisingIndexRouteImport
      parentRoute: typeof AppFundraisingRoute
    }
    '/_app/_/forms/': {
      id: '/_app/_/forms/'
      path: '/'
      fullPath: '/forms/'
      preLoaderRoute: typeof AppFormsIndexRouteImport
      parentRoute: typeof AppFormsRoute
    }
    '/_app/_/email/': {
      id: '/_app/_/email/'
      path: '/'
      fullPath: '/email/'
      preLoaderRoute: typeof AppEmailIndexRouteImport
      parentRoute: typeof AppEmailRoute
    }
    '/_app/_/daily-briefing/': {
      id: '/_app/_/daily-briefing/'
      path: '/'
      fullPath: '/daily-briefing/'
      preLoaderRoute: typeof AppDailyBriefingIndexRouteImport
      parentRoute: typeof AppDailyBriefingRoute
    }
    '/_app/_/contacts/': {
      id: '/_app/_/contacts/'
      path: '/'
      fullPath: '/contacts/'
      preLoaderRoute: typeof AppContactsIndexRouteImport
      parentRoute: typeof AppContactsRoute
    }
    '/_app/_/campaigns/': {
      id: '/_app/_/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof AppCampaignsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/call-time/': {
      id: '/_app/_/call-time/'
      path: '/'
      fullPath: '/call-time/'
      preLoaderRoute: typeof AppCallTimeIndexRouteImport
      parentRoute: typeof AppCallTimeRoute
    }
    '/_app/_/ballot-access/': {
      id: '/_app/_/ballot-access/'
      path: '/'
      fullPath: '/ballot-access/'
      preLoaderRoute: typeof AppBallotAccessIndexRouteImport
      parentRoute: typeof AppBallotAccessRoute
    }
    '/_app/_/action-groups/': {
      id: '/_app/_/action-groups/'
      path: '/'
      fullPath: '/action-groups/'
      preLoaderRoute: typeof AppActionGroupsIndexRouteImport
      parentRoute: typeof AppActionGroupsRoute
    }
    '/_app/_/volunteers/$volunteerId': {
      id: '/_app/_/volunteers/$volunteerId'
      path: '/$volunteerId'
      fullPath: '/volunteers/$volunteerId'
      preLoaderRoute: typeof AppVolunteersVolunteerIdRouteImport
      parentRoute: typeof AppVolunteersRoute
    }
    '/_app/_/text-banking/new': {
      id: '/_app/_/text-banking/new'
      path: '/new'
      fullPath: '/text-banking/new'
      preLoaderRoute: typeof AppTextBankingNewRouteImport
      parentRoute: typeof AppTextBankingRoute
    }
    '/_app/_/text-banking/$campaignId': {
      id: '/_app/_/text-banking/$campaignId'
      path: '/$campaignId'
      fullPath: '/text-banking/$campaignId'
      preLoaderRoute: typeof AppTextBankingCampaignIdRouteImport
      parentRoute: typeof AppTextBankingRoute
    }
    '/_app/_/strategy/versions': {
      id: '/_app/_/strategy/versions'
      path: '/versions'
      fullPath: '/strategy/versions'
      preLoaderRoute: typeof AppStrategyVersionsRouteImport
      parentRoute: typeof AppStrategyRoute
    }
    '/_app/_/strategy/roadmap': {
      id: '/_app/_/strategy/roadmap'
      path: '/roadmap'
      fullPath: '/strategy/roadmap'
      preLoaderRoute: typeof AppStrategyRoadmapRouteImport
      parentRoute: typeof AppStrategyRoute
    }
    '/_app/_/strategy/reveal': {
      id: '/_app/_/strategy/reveal'
      path: '/reveal'
      fullPath: '/strategy/reveal'
      preLoaderRoute: typeof AppStrategyRevealRouteImport
      parentRoute: typeof AppStrategyRoute
    }
    '/_app/_/strategy/qa': {
      id: '/_app/_/strategy/qa'
      path: '/qa'
      fullPath: '/strategy/qa'
      preLoaderRoute: typeof AppStrategyQaRouteImport
      parentRoute: typeof AppStrategyRoute
    }
    '/_app/_/strategy/dashboard': {
      id: '/_app/_/strategy/dashboard'
      path: '/dashboard'
      fullPath: '/strategy/dashboard'
      preLoaderRoute: typeof AppStrategyDashboardRouteImport
      parentRoute: typeof AppStrategyRoute
    }
    '/_app/_/strategy/brief': {
      id: '/_app/_/strategy/brief'
      path: '/brief'
      fullPath: '/strategy/brief'
      preLoaderRoute: typeof AppStrategyBriefRouteImport
      parentRoute: typeof AppStrategyRoute
    }
    '/_app/_/phone-banking/new': {
      id: '/_app/_/phone-banking/new'
      path: '/new'
      fullPath: '/phone-banking/new'
      preLoaderRoute: typeof AppPhoneBankingNewRouteImport
      parentRoute: typeof AppPhoneBankingRoute
    }
    '/_app/_/phone-banking/$campaignId': {
      id: '/_app/_/phone-banking/$campaignId'
      path: '/$campaignId'
      fullPath: '/phone-banking/$campaignId'
      preLoaderRoute: typeof AppPhoneBankingCampaignIdRouteImport
      parentRoute: typeof AppPhoneBankingRoute
    }
    '/_app/_/outreach/new': {
      id: '/_app/_/outreach/new'
      path: '/outreach/new'
      fullPath: '/outreach/new'
      preLoaderRoute: typeof AppOutreachNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/outreach/group-audiences': {
      id: '/_app/_/outreach/group-audiences'
      path: '/outreach/group-audiences'
      fullPath: '/outreach/group-audiences'
      preLoaderRoute: typeof AppOutreachGroupAudiencesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/outreach/audiences': {
      id: '/_app/_/outreach/audiences'
      path: '/outreach/audiences'
      fullPath: '/outreach/audiences'
      preLoaderRoute: typeof AppOutreachAudiencesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/outreach/$ocId': {
      id: '/_app/_/outreach/$ocId'
      path: '/outreach/$ocId'
      fullPath: '/outreach/$ocId'
      preLoaderRoute: typeof AppOutreachOcIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/onboarding/mic-setup': {
      id: '/_app/_/onboarding/mic-setup'
      path: '/mic-setup'
      fullPath: '/onboarding/mic-setup'
      preLoaderRoute: typeof AppOnboardingMicSetupRouteImport
      parentRoute: typeof AppOnboardingRoute
    }
    '/_app/_/onboarding/interview-intro': {
      id: '/_app/_/onboarding/interview-intro'
      path: '/interview-intro'
      fullPath: '/onboarding/interview-intro'
      preLoaderRoute: typeof AppOnboardingInterviewIntroRouteImport
      parentRoute: typeof AppOnboardingRoute
    }
    '/_app/_/onboarding/interview-follow-up': {
      id: '/_app/_/onboarding/interview-follow-up'
      path: '/interview-follow-up'
      fullPath: '/onboarding/interview-follow-up'
      preLoaderRoute: typeof AppOnboardingInterviewFollowUpRouteImport
      parentRoute: typeof AppOnboardingRoute
    }
    '/_app/_/onboarding/get-started': {
      id: '/_app/_/onboarding/get-started'
      path: '/get-started'
      fullPath: '/onboarding/get-started'
      preLoaderRoute: typeof AppOnboardingGetStartedRouteImport
      parentRoute: typeof AppOnboardingRoute
    }
    '/_app/_/onboarding/generating': {
      id: '/_app/_/onboarding/generating'
      path: '/generating'
      fullPath: '/onboarding/generating'
      preLoaderRoute: typeof AppOnboardingGeneratingRouteImport
      parentRoute: typeof AppOnboardingRoute
    }
    '/_app/_/onboarding/accept-tos': {
      id: '/_app/_/onboarding/accept-tos'
      path: '/accept-tos'
      fullPath: '/onboarding/accept-tos'
      preLoaderRoute: typeof AppOnboardingAcceptTosRouteImport
      parentRoute: typeof AppOnboardingRoute
    }
    '/_app/_/interview/session': {
      id: '/_app/_/interview/session'
      path: '/session'
      fullPath: '/interview/session'
      preLoaderRoute: typeof AppInterviewSessionRouteImport
      parentRoute: typeof AppInterviewRoute
    }
    '/_app/_/fundraising/setup': {
      id: '/_app/_/fundraising/setup'
      path: '/setup'
      fullPath: '/fundraising/setup'
      preLoaderRoute: typeof AppFundraisingSetupRouteImport
      parentRoute: typeof AppFundraisingRoute
    }
    '/_app/_/fundraising/settings': {
      id: '/_app/_/fundraising/settings'
      path: '/settings'
      fullPath: '/fundraising/settings'
      preLoaderRoute: typeof AppFundraisingSettingsRouteImport
      parentRoute: typeof AppFundraisingRoute
    }
    '/_app/_/fundraising/page-builder': {
      id: '/_app/_/fundraising/page-builder'
      path: '/page-builder'
      fullPath: '/fundraising/page-builder'
      preLoaderRoute: typeof AppFundraisingPageBuilderRouteImport
      parentRoute: typeof AppFundraisingRoute
    }
    '/_app/_/fundraising/donations': {
      id: '/_app/_/fundraising/donations'
      path: '/donations'
      fullPath: '/fundraising/donations'
      preLoaderRoute: typeof AppFundraisingDonationsRouteImport
      parentRoute: typeof AppFundraisingRoute
    }
    '/_app/_/fundraising/compliance': {
      id: '/_app/_/fundraising/compliance'
      path: '/compliance'
      fullPath: '/fundraising/compliance'
      preLoaderRoute: typeof AppFundraisingComplianceRouteImport
      parentRoute: typeof AppFundraisingRoute
    }
    '/_app/_/forms/new': {
      id: '/_app/_/forms/new'
      path: '/new'
      fullPath: '/forms/new'
      preLoaderRoute: typeof AppFormsNewRouteImport
      parentRoute: typeof AppFormsRoute
    }
    '/_app/_/forms/$formId': {
      id: '/_app/_/forms/$formId'
      path: '/$formId'
      fullPath: '/forms/$formId'
      preLoaderRoute: typeof AppFormsFormIdRouteImport
      parentRoute: typeof AppFormsRoute
    }
    '/_app/_/contacts/import': {
      id: '/_app/_/contacts/import'
      path: '/import'
      fullPath: '/contacts/import'
      preLoaderRoute: typeof AppContactsImportRouteImport
      parentRoute: typeof AppContactsRoute
    }
    '/_app/_/contacts/$contactId': {
      id: '/_app/_/contacts/$contactId'
      path: '/$contactId'
      fullPath: '/contacts/$contactId'
      preLoaderRoute: typeof AppContactsContactIdRouteImport
      parentRoute: typeof AppContactsRoute
    }
    '/_app/_/campaigns/new': {
      id: '/_app/_/campaigns/new'
      path: '/campaigns/new'
      fullPath: '/campaigns/new'
      preLoaderRoute: typeof AppCampaignsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/campaigns/$goalId': {
      id: '/_app/_/campaigns/$goalId'
      path: '/campaigns/$goalId'
      fullPath: '/campaigns/$goalId'
      preLoaderRoute: typeof AppCampaignsGoalIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_/call-time/results': {
      id: '/_app/_/call-time/results'
      path: '/results'
      fullPath: '/call-time/results'
      preLoaderRoute: typeof AppCallTimeResultsRouteImport
      parentRoute: typeof AppCallTimeRoute
    }
    '/_app/_/call-time/manage': {
      id: '/_app/_/call-time/manage'
      path: '/manage'
      fullPath: '/call-time/manage'
      preLoaderRoute: typeof AppCallTimeManageRouteImport
      parentRoute: typeof AppCallTimeRoute
    }
    '/_app/_/ballot-access/$driveId': {
      id: '/_app/_/ballot-access/$driveId'
      path: '/$driveId'
      fullPath: '/ballot-access/$driveId'
      preLoaderRoute: typeof AppBallotAccessDriveIdRouteImport
      parentRoute: typeof AppBallotAccessRoute
    }
    '/_app/_/action-groups/suggestions': {
      id: '/_app/_/action-groups/suggestions'
      path: '/suggestions'
      fullPath: '/action-groups/suggestions'
      preLoaderRoute: typeof AppActionGroupsSuggestionsRouteImport
      parentRoute: typeof AppActionGroupsRoute
    }
    '/_app/_/action-groups/alerts': {
      id: '/_app/_/action-groups/alerts'
      path: '/alerts'
      fullPath: '/action-groups/alerts'
      preLoaderRoute: typeof AppActionGroupsAlertsRouteImport
      parentRoute: typeof AppActionGroupsRoute
    }
    '/_app/_/action-groups/$groupId': {
      id: '/_app/_/action-groups/$groupId'
      path: '/$groupId'
      fullPath: '/action-groups/$groupId'
      preLoaderRoute: typeof AppActionGroupsGroupIdRouteImport
      parentRoute: typeof AppActionGroupsRoute
    }
    '/_app/_/phone-banking/$campaignId/': {
      id: '/_app/_/phone-banking/$campaignId/'
      path: '/'
      fullPath: '/phone-banking/$campaignId/'
      preLoaderRoute: typeof AppPhoneBankingCampaignIdIndexRouteImport
      parentRoute: typeof AppPhoneBankingCampaignIdRoute
    }
    '/_app/_/phone-banking/$campaignId/call': {
      id: '/_app/_/phone-banking/$campaignId/call'
      path: '/call'
      fullPath: '/phone-banking/$campaignId/call'
      preLoaderRoute: typeof AppPhoneBankingCampaignIdCallRouteImport
      parentRoute: typeof AppPhoneBankingCampaignIdRoute
    }
    '/_app/_/fundraising/donors/$donorId': {
      id: '/_app/_/fundraising/donors/$donorId'
      path: '/donors/$donorId'
      fullPath: '/fundraising/donors/$donorId'
      preLoaderRoute: typeof AppFundraisingDonorsDonorIdRouteImport
      parentRoute: typeof AppFundraisingRoute
    }
    '/_app/_/contacts/voter-file/$l2VoterId': {
      id: '/_app/_/contacts/voter-file/$l2VoterId'
      path: '/voter-file/$l2VoterId'
      fullPath: '/contacts/voter-file/$l2VoterId'
      preLoaderRoute: typeof AppContactsVoterFileL2VoterIdRouteImport
      parentRoute: typeof AppContactsRoute
    }
    '/_app/_/contacts/text-banking/new': {
      id: '/_app/_/contacts/text-banking/new'
      path: '/text-banking/new'
      fullPath: '/contacts/text-banking/new'
      preLoaderRoute: typeof AppContactsTextBankingNewRouteImport
      parentRoute: typeof AppContactsRoute
    }
    '/_app/_/contacts/text-banking/$campaignId': {
      id: '/_app/_/contacts/text-banking/$campaignId'
      path: '/text-banking/$campaignId'
      fullPath: '/contacts/text-banking/$campaignId'
      preLoaderRoute: typeof AppContactsTextBankingCampaignIdRouteImport
      parentRoute: typeof AppContactsRoute
    }
    '/_app/_/contacts/phone-banking/$campaignId': {
      id: '/_app/_/contacts/phone-banking/$campaignId'
      path: '/phone-banking/$campaignId'
      fullPath: '/contacts/phone-banking/$campaignId'
      preLoaderRoute: typeof AppContactsPhoneBankingCampaignIdRouteImport
      parentRoute: typeof AppContactsRoute
    }
    '/_app/_/contacts/email/new': {
      id: '/_app/_/contacts/email/new'
      path: '/email/new'
      fullPath: '/contacts/email/new'
      preLoaderRoute: typeof AppContactsEmailNewRouteImport
      parentRoute: typeof AppContactsRoute
    }
    '/_app/_/contacts/email/$emailId': {
      id: '/_app/_/contacts/email/$emailId'
      path: '/email/$emailId'
      fullPath: '/contacts/email/$emailId'
      preLoaderRoute: typeof AppContactsEmailEmailIdRouteImport
      parentRoute: typeof AppContactsRoute
    }
  }
}

interface AppSettingsRouteChildren {
  AppSettingsBillingRoute: typeof AppSettingsBillingRoute
  AppSettingsEmailSettingsRoute: typeof AppSettingsEmailSettingsRoute
  AppSettingsFundraisingSettingsRoute: typeof AppSettingsFundraisingSettingsRoute
  AppSettingsSettingsRoute: typeof AppSettingsSettingsRoute
  AppSettingsTeamRoute: typeof AppSettingsTeamRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsBillingRoute: AppSettingsBillingRoute,
  AppSettingsEmailSettingsRoute: AppSettingsEmailSettingsRoute,
  AppSettingsFundraisingSettingsRoute: AppSettingsFundraisingSettingsRoute,
  AppSettingsSettingsRoute: AppSettingsSettingsRoute,
  AppSettingsTeamRoute: AppSettingsTeamRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppActionGroupsRouteChildren {
  AppActionGroupsGroupIdRoute: typeof AppActionGroupsGroupIdRoute
  AppActionGroupsAlertsRoute: typeof AppActionGroupsAlertsRoute
  AppActionGroupsSuggestionsRoute: typeof AppActionGroupsSuggestionsRoute
  AppActionGroupsIndexRoute: typeof AppActionGroupsIndexRoute
}

const AppActionGroupsRouteChildren: AppActionGroupsRouteChildren = {
  AppActionGroupsGroupIdRoute: AppActionGroupsGroupIdRoute,
  AppActionGroupsAlertsRoute: AppActionGroupsAlertsRoute,
  AppActionGroupsSuggestionsRoute: AppActionGroupsSuggestionsRoute,
  AppActionGroupsIndexRoute: AppActionGroupsIndexRoute,
}

const AppActionGroupsRouteWithChildren = AppActionGroupsRoute._addFileChildren(
  AppActionGroupsRouteChildren,
)

interface AppBallotAccessRouteChildren {
  AppBallotAccessDriveIdRoute: typeof AppBallotAccessDriveIdRoute
  AppBallotAccessIndexRoute: typeof AppBallotAccessIndexRoute
}

const AppBallotAccessRouteChildren: AppBallotAccessRouteChildren = {
  AppBallotAccessDriveIdRoute: AppBallotAccessDriveIdRoute,
  AppBallotAccessIndexRoute: AppBallotAccessIndexRoute,
}

const AppBallotAccessRouteWithChildren = AppBallotAccessRoute._addFileChildren(
  AppBallotAccessRouteChildren,
)

interface AppCallTimeRouteChildren {
  AppCallTimeManageRoute: typeof AppCallTimeManageRoute
  AppCallTimeResultsRoute: typeof AppCallTimeResultsRoute
  AppCallTimeIndexRoute: typeof AppCallTimeIndexRoute
}

const AppCallTimeRouteChildren: AppCallTimeRouteChildren = {
  AppCallTimeManageRoute: AppCallTimeManageRoute,
  AppCallTimeResultsRoute: AppCallTimeResultsRoute,
  AppCallTimeIndexRoute: AppCallTimeIndexRoute,
}

const AppCallTimeRouteWithChildren = AppCallTimeRoute._addFileChildren(
  AppCallTimeRouteChildren,
)

interface AppContactsRouteChildren {
  AppContactsContactIdRoute: typeof AppContactsContactIdRoute
  AppContactsImportRoute: typeof AppContactsImportRoute
  AppContactsIndexRoute: typeof AppContactsIndexRoute
  AppContactsEmailEmailIdRoute: typeof AppContactsEmailEmailIdRoute
  AppContactsEmailNewRoute: typeof AppContactsEmailNewRoute
  AppContactsPhoneBankingCampaignIdRoute: typeof AppContactsPhoneBankingCampaignIdRoute
  AppContactsTextBankingCampaignIdRoute: typeof AppContactsTextBankingCampaignIdRoute
  AppContactsTextBankingNewRoute: typeof AppContactsTextBankingNewRoute
  AppContactsVoterFileL2VoterIdRoute: typeof AppContactsVoterFileL2VoterIdRoute
}

const AppContactsRouteChildren: AppContactsRouteChildren = {
  AppContactsContactIdRoute: AppContactsContactIdRoute,
  AppContactsImportRoute: AppContactsImportRoute,
  AppContactsIndexRoute: AppContactsIndexRoute,
  AppContactsEmailEmailIdRoute: AppContactsEmailEmailIdRoute,
  AppContactsEmailNewRoute: AppContactsEmailNewRoute,
  AppContactsPhoneBankingCampaignIdRoute:
    AppContactsPhoneBankingCampaignIdRoute,
  AppContactsTextBankingCampaignIdRoute: AppContactsTextBankingCampaignIdRoute,
  AppContactsTextBankingNewRoute: AppContactsTextBankingNewRoute,
  AppContactsVoterFileL2VoterIdRoute: AppContactsVoterFileL2VoterIdRoute,
}

const AppContactsRouteWithChildren = AppContactsRoute._addFileChildren(
  AppContactsRouteChildren,
)

interface AppDailyBriefingRouteChildren {
  AppDailyBriefingIndexRoute: typeof AppDailyBriefingIndexRoute
}

const AppDailyBriefingRouteChildren: AppDailyBriefingRouteChildren = {
  AppDailyBriefingIndexRoute: AppDailyBriefingIndexRoute,
}

const AppDailyBriefingRouteWithChildren =
  AppDailyBriefingRoute._addFileChildren(AppDailyBriefingRouteChildren)

interface AppEmailRouteChildren {
  AppEmailIndexRoute: typeof AppEmailIndexRoute
}

const AppEmailRouteChildren: AppEmailRouteChildren = {
  AppEmailIndexRoute: AppEmailIndexRoute,
}

const AppEmailRouteWithChildren = AppEmailRoute._addFileChildren(
  AppEmailRouteChildren,
)

interface AppFormsRouteChildren {
  AppFormsFormIdRoute: typeof AppFormsFormIdRoute
  AppFormsNewRoute: typeof AppFormsNewRoute
  AppFormsIndexRoute: typeof AppFormsIndexRoute
}

const AppFormsRouteChildren: AppFormsRouteChildren = {
  AppFormsFormIdRoute: AppFormsFormIdRoute,
  AppFormsNewRoute: AppFormsNewRoute,
  AppFormsIndexRoute: AppFormsIndexRoute,
}

const AppFormsRouteWithChildren = AppFormsRoute._addFileChildren(
  AppFormsRouteChildren,
)

interface AppFundraisingRouteChildren {
  AppFundraisingComplianceRoute: typeof AppFundraisingComplianceRoute
  AppFundraisingDonationsRoute: typeof AppFundraisingDonationsRoute
  AppFundraisingPageBuilderRoute: typeof AppFundraisingPageBuilderRoute
  AppFundraisingSettingsRoute: typeof AppFundraisingSettingsRoute
  AppFundraisingSetupRoute: typeof AppFundraisingSetupRoute
  AppFundraisingIndexRoute: typeof AppFundraisingIndexRoute
  AppFundraisingDonorsDonorIdRoute: typeof AppFundraisingDonorsDonorIdRoute
}

const AppFundraisingRouteChildren: AppFundraisingRouteChildren = {
  AppFundraisingComplianceRoute: AppFundraisingComplianceRoute,
  AppFundraisingDonationsRoute: AppFundraisingDonationsRoute,
  AppFundraisingPageBuilderRoute: AppFundraisingPageBuilderRoute,
  AppFundraisingSettingsRoute: AppFundraisingSettingsRoute,
  AppFundraisingSetupRoute: AppFundraisingSetupRoute,
  AppFundraisingIndexRoute: AppFundraisingIndexRoute,
  AppFundraisingDonorsDonorIdRoute: AppFundraisingDonorsDonorIdRoute,
}

const AppFundraisingRouteWithChildren = AppFundraisingRoute._addFileChildren(
  AppFundraisingRouteChildren,
)

interface AppInterviewRouteChildren {
  AppInterviewSessionRoute: typeof AppInterviewSessionRoute
}

const AppInterviewRouteChildren: AppInterviewRouteChildren = {
  AppInterviewSessionRoute: AppInterviewSessionRoute,
}

const AppInterviewRouteWithChildren = AppInterviewRoute._addFileChildren(
  AppInterviewRouteChildren,
)

interface AppOnboardingRouteChildren {
  AppOnboardingAcceptTosRoute: typeof AppOnboardingAcceptTosRoute
  AppOnboardingGeneratingRoute: typeof AppOnboardingGeneratingRoute
  AppOnboardingGetStartedRoute: typeof AppOnboardingGetStartedRoute
  AppOnboardingInterviewFollowUpRoute: typeof AppOnboardingInterviewFollowUpRoute
  AppOnboardingInterviewIntroRoute: typeof AppOnboardingInterviewIntroRoute
  AppOnboardingMicSetupRoute: typeof AppOnboardingMicSetupRoute
}

const AppOnboardingRouteChildren: AppOnboardingRouteChildren = {
  AppOnboardingAcceptTosRoute: AppOnboardingAcceptTosRoute,
  AppOnboardingGeneratingRoute: AppOnboardingGeneratingRoute,
  AppOnboardingGetStartedRoute: AppOnboardingGetStartedRoute,
  AppOnboardingInterviewFollowUpRoute: AppOnboardingInterviewFollowUpRoute,
  AppOnboardingInterviewIntroRoute: AppOnboardingInterviewIntroRoute,
  AppOnboardingMicSetupRoute: AppOnboardingMicSetupRoute,
}

const AppOnboardingRouteWithChildren = AppOnboardingRoute._addFileChildren(
  AppOnboardingRouteChildren,
)

interface AppPhoneBankingCampaignIdRouteChildren {
  AppPhoneBankingCampaignIdCallRoute: typeof AppPhoneBankingCampaignIdCallRoute
  AppPhoneBankingCampaignIdIndexRoute: typeof AppPhoneBankingCampaignIdIndexRoute
}

const AppPhoneBankingCampaignIdRouteChildren: AppPhoneBankingCampaignIdRouteChildren =
  {
    AppPhoneBankingCampaignIdCallRoute: AppPhoneBankingCampaignIdCallRoute,
    AppPhoneBankingCampaignIdIndexRoute: AppPhoneBankingCampaignIdIndexRoute,
  }

const AppPhoneBankingCampaignIdRouteWithChildren =
  AppPhoneBankingCampaignIdRoute._addFileChildren(
    AppPhoneBankingCampaignIdRouteChildren,
  )

interface AppPhoneBankingRouteChildren {
  AppPhoneBankingCampaignIdRoute: typeof AppPhoneBankingCampaignIdRouteWithChildren
  AppPhoneBankingNewRoute: typeof AppPhoneBankingNewRoute
  AppPhoneBankingIndexRoute: typeof AppPhoneBankingIndexRoute
}

const AppPhoneBankingRouteChildren: AppPhoneBankingRouteChildren = {
  AppPhoneBankingCampaignIdRoute: AppPhoneBankingCampaignIdRouteWithChildren,
  AppPhoneBankingNewRoute: AppPhoneBankingNewRoute,
  AppPhoneBankingIndexRoute: AppPhoneBankingIndexRoute,
}

const AppPhoneBankingRouteWithChildren = AppPhoneBankingRoute._addFileChildren(
  AppPhoneBankingRouteChildren,
)

interface AppStrategyRouteChildren {
  AppStrategyBriefRoute: typeof AppStrategyBriefRoute
  AppStrategyDashboardRoute: typeof AppStrategyDashboardRoute
  AppStrategyQaRoute: typeof AppStrategyQaRoute
  AppStrategyRevealRoute: typeof AppStrategyRevealRoute
  AppStrategyRoadmapRoute: typeof AppStrategyRoadmapRoute
  AppStrategyVersionsRoute: typeof AppStrategyVersionsRoute
  AppStrategyIndexRoute: typeof AppStrategyIndexRoute
}

const AppStrategyRouteChildren: AppStrategyRouteChildren = {
  AppStrategyBriefRoute: AppStrategyBriefRoute,
  AppStrategyDashboardRoute: AppStrategyDashboardRoute,
  AppStrategyQaRoute: AppStrategyQaRoute,
  AppStrategyRevealRoute: AppStrategyRevealRoute,
  AppStrategyRoadmapRoute: AppStrategyRoadmapRoute,
  AppStrategyVersionsRoute: AppStrategyVersionsRoute,
  AppStrategyIndexRoute: AppStrategyIndexRoute,
}

const AppStrategyRouteWithChildren = AppStrategyRoute._addFileChildren(
  AppStrategyRouteChildren,
)

interface AppTasksRouteChildren {
  AppTasksIndexRoute: typeof AppTasksIndexRoute
}

const AppTasksRouteChildren: AppTasksRouteChildren = {
  AppTasksIndexRoute: AppTasksIndexRoute,
}

const AppTasksRouteWithChildren = AppTasksRoute._addFileChildren(
  AppTasksRouteChildren,
)

interface AppTextBankingRouteChildren {
  AppTextBankingCampaignIdRoute: typeof AppTextBankingCampaignIdRoute
  AppTextBankingNewRoute: typeof AppTextBankingNewRoute
  AppTextBankingIndexRoute: typeof AppTextBankingIndexRoute
}

const AppTextBankingRouteChildren: AppTextBankingRouteChildren = {
  AppTextBankingCampaignIdRoute: AppTextBankingCampaignIdRoute,
  AppTextBankingNewRoute: AppTextBankingNewRoute,
  AppTextBankingIndexRoute: AppTextBankingIndexRoute,
}

const AppTextBankingRouteWithChildren = AppTextBankingRoute._addFileChildren(
  AppTextBankingRouteChildren,
)

interface AppVolunteersRouteChildren {
  AppVolunteersVolunteerIdRoute: typeof AppVolunteersVolunteerIdRoute
  AppVolunteersIndexRoute: typeof AppVolunteersIndexRoute
}

const AppVolunteersRouteChildren: AppVolunteersRouteChildren = {
  AppVolunteersVolunteerIdRoute: AppVolunteersVolunteerIdRoute,
  AppVolunteersIndexRoute: AppVolunteersIndexRoute,
}

const AppVolunteersRouteWithChildren = AppVolunteersRoute._addFileChildren(
  AppVolunteersRouteChildren,
)

interface AppVoterFileStatsRouteChildren {
  AppVoterFileStatsIndexRoute: typeof AppVoterFileStatsIndexRoute
}

const AppVoterFileStatsRouteChildren: AppVoterFileStatsRouteChildren = {
  AppVoterFileStatsIndexRoute: AppVoterFileStatsIndexRoute,
}

const AppVoterFileStatsRouteWithChildren =
  AppVoterFileStatsRoute._addFileChildren(AppVoterFileStatsRouteChildren)

interface AppRouteChildren {
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppActionGroupsRoute: typeof AppActionGroupsRouteWithChildren
  AppBallotAccessRoute: typeof AppBallotAccessRouteWithChildren
  AppCallTimeRoute: typeof AppCallTimeRouteWithChildren
  AppCommandCenterRoute: typeof AppCommandCenterRoute
  AppContactsRoute: typeof AppContactsRouteWithChildren
  AppDailyBriefingRoute: typeof AppDailyBriefingRouteWithChildren
  AppEmailRoute: typeof AppEmailRouteWithChildren
  AppFormsRoute: typeof AppFormsRouteWithChildren
  AppFundraisingRoute: typeof AppFundraisingRouteWithChildren
  AppInterviewRoute: typeof AppInterviewRouteWithChildren
  AppOnboardingRoute: typeof AppOnboardingRouteWithChildren
  AppPhoneBankingRoute: typeof AppPhoneBankingRouteWithChildren
  AppProfileRoute: typeof AppProfileRoute
  AppStrategyRoute: typeof AppStrategyRouteWithChildren
  AppTasksRoute: typeof AppTasksRouteWithChildren
  AppTextBankingRoute: typeof AppTextBankingRouteWithChildren
  AppVolunteersRoute: typeof AppVolunteersRouteWithChildren
  AppVoterFileStatsRoute: typeof AppVoterFileStatsRouteWithChildren
  AppYourVotersRoute: typeof AppYourVotersRoute
  AppIndexRoute: typeof AppIndexRoute
  AppCampaignsGoalIdRoute: typeof AppCampaignsGoalIdRoute
  AppCampaignsNewRoute: typeof AppCampaignsNewRoute
  AppOutreachOcIdRoute: typeof AppOutreachOcIdRoute
  AppOutreachAudiencesRoute: typeof AppOutreachAudiencesRoute
  AppOutreachGroupAudiencesRoute: typeof AppOutreachGroupAudiencesRoute
  AppOutreachNewRoute: typeof AppOutreachNewRoute
  AppCampaignsIndexRoute: typeof AppCampaignsIndexRoute
  AppOutreachIndexRoute: typeof AppOutreachIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppActionGroupsRoute: AppActionGroupsRouteWithChildren,
  AppBallotAccessRoute: AppBallotAccessRouteWithChildren,
  AppCallTimeRoute: AppCallTimeRouteWithChildren,
  AppCommandCenterRoute: AppCommandCenterRoute,
  AppContactsRoute: AppContactsRouteWithChildren,
  AppDailyBriefingRoute: AppDailyBriefingRouteWithChildren,
  AppEmailRoute: AppEmailRouteWithChildren,
  AppFormsRoute: AppFormsRouteWithChildren,
  AppFundraisingRoute: AppFundraisingRouteWithChildren,
  AppInterviewRoute: AppInterviewRouteWithChildren,
  AppOnboardingRoute: AppOnboardingRouteWithChildren,
  AppPhoneBankingRoute: AppPhoneBankingRouteWithChildren,
  AppProfileRoute: AppProfileRoute,
  AppStrategyRoute: AppStrategyRouteWithChildren,
  AppTasksRoute: AppTasksRouteWithChildren,
  AppTextBankingRoute: AppTextBankingRouteWithChildren,
  AppVolunteersRoute: AppVolunteersRouteWithChildren,
  AppVoterFileStatsRoute: AppVoterFileStatsRouteWithChildren,
  AppYourVotersRoute: AppYourVotersRoute,
  AppIndexRoute: AppIndexRoute,
  AppCampaignsGoalIdRoute: AppCampaignsGoalIdRoute,
  AppCampaignsNewRoute: AppCampaignsNewRoute,
  AppOutreachOcIdRoute: AppOutreachOcIdRoute,
  AppOutreachAudiencesRoute: AppOutreachAudiencesRoute,
  AppOutreachGroupAudiencesRoute: AppOutreachGroupAudiencesRoute,
  AppOutreachNewRoute: AppOutreachNewRoute,
  AppCampaignsIndexRoute: AppCampaignsIndexRoute,
  AppOutreachIndexRoute: AppOutreachIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AdminRouteChildren {
  AdminSplatRoute: typeof AdminSplatRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminSplatRoute: AdminSplatRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AuthLoginRouteChildren {
  AuthLoginGoogleCallbackRoute: typeof AuthLoginGoogleCallbackRoute
}

const AuthLoginRouteChildren: AuthLoginRouteChildren = {
  AuthLoginGoogleCallbackRoute: AuthLoginGoogleCallbackRoute,
}

const AuthLoginRouteWithChildren = AuthLoginRoute._addFileChildren(
  AuthLoginRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AdminRoute: AdminRouteWithChildren,
  PlatformIntroRoute: PlatformIntroRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
  AuthLoginRoute: AuthLoginRouteWithChildren,
  AuthPendingApprovalRoute: AuthPendingApprovalRoute,
  AuthSignupRoute: AuthSignupRoute,
  AuthAcceptInviteRoute: AuthAcceptInviteRoute,
  AuthCreatePasswordRoute: AuthCreatePasswordRoute,
  AuthGoogleCallbackRoute: AuthGoogleCallbackRoute,
  AuthPhoneVerificationRoute: AuthPhoneVerificationRoute,
  AuthRegisterInviteRoute: AuthRegisterInviteRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthVerifyRoute: AuthVerifyRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
  CheckoutSuccessTokenRoute: CheckoutSuccessTokenRoute,
  CheckoutTokenRoute: CheckoutTokenRoute,
  CheckoutSuccessRoute: CheckoutSuccessRoute,
  DonateSlugRoute: DonateSlugRoute,
  StrategyMagicLinkRoute: StrategyMagicLinkRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
